module.exports = {
  "+1Wujb": "{num}개 항목",
  "+4lD9e": "이름",
  "+L9lak": "알람 템플릿 적용",
  "+bRanp": "최대 알림 개수를 입력하세요",
  "+d7aNN": "알람 템플릿 목록",
  "/COTHZ": "알람 모듈 이름은 비워둘 수 없습니다.",
  "/cqdKk": "다운로드",
  "/l9tS2": "트리거되지 않음",
  "/sI6h+": "사람",
  "03eM6t": "200개 항목/페이지",
  "0JCY6+": "배포자",
  "0sn8j/": "이름을 입력하세요",
  "1UXyeT": "트리거 시간",
  "1WymPU": "경보 트리거 값 선택",
  "2+X2n8": "일괄 삭제",
  "28oE7E": "선택된 장치가 없습니다",
  "29A4OA": "회사 회원",
  "2QzYmY": "취소",
  "2rDc7R": "경보 규칙은 비워둘 수 없습니다.",
  "2t0Cct": "배포 날짜",
  "32AbcK": "회사 선택",
  "36+mbi": "처리 상태",
  "3HzQUc": "JSON 내보내기",
  "3RVwfq": "의견을 작성해 주세요",
  pGioLb: "장치 순서 SN",
  "wnPTP+": "장치 SN 입력",
  i5Nyva: "읽지 않음",
  P76mDe: "동기 파일 관리",
  ich0wH: "장치 SN",
  wpKIvP: "읽기",
  "5EJNIu": "회사 전체의 장비 검색",
  wDqNy1: "예",
  "3aYG4L":
    "현재 장치에 적용된 알람 템플릿을 제거하고 더 이상 알람을 모니터링하거나 보내지 않습니다.",
  "3qVnoZ": "장치 수 ({num})",
  "4/e9qs": "이름을 입력하세요",
  "4VVrWd":
    "({name}) 알람 템플릿을 비활성화하시겠습니까? 비활성화한 후에는 새 알람 장치가 템플릿을 적용할 수 없습니다.",
  "4vWL+W": "장치 가져오기",
  "4wi+/p": "템플릿",
  "5SSVAQ": "새 알람 템플릿",
  "5grmob": "이메일 주소를 입력하세요",
  "5p8cBO": "계정 관리",
  "60Ixlm": "알람 템플릿 이름",
  "6ABIlp": "트리거 상태",
  "6mjOF/": "일괄 재설정",
  "7G1c4h": "장치 목록",
  "8PESa6": "비활성화",
  "919TK9": "지원되는 형식: xls, xlsx",
  "9Kfib+": "알 수 없는 오류",
  "9UefLp": "라벨",
  B57Wbu: "선택된 장치가 없습니다",
  BC74I9: "프롬프트 메시지",
  BQcLxf: "아래로 이동",
  BYbqwY: "파일을 여기로 드래그하거나 클릭하여 업로드하세요.",
  BhkglP: "토큰 보기",
  BwXapw: "카테고리 이름을 500자 이내로 조절해주세요",
  CLqPBU: "편집",
  D3lDHK: "경보 규칙 추가",
  D5HOUz: "상태 선택",
  E2kRYi: "일괄 활성화",
  "EZ+vMa": "템플릿 주석",
  EwM8Kj: "정말 이사하시겠습니까?",
  Ey9rBq: "삭제하시겠습니까?",
  F2LJDJ: "정말로 제거하시겠습니까?",
  F56ZKt: "멤버 선택",
  FEb7U2: "확인",
  "FaJ/jI": "가져오기 위해 선택한 파일이 없습니다",
  FbCeo1: "트리거 값",
  FbsCUK: "휴대폰",
  FeJVkL: "추가 수신자 추가",
  "Fr1I/b": "라벨",
  "G+BH4o": "현재 장치({name})를 삭제하시겠습니까?",
  GKSW97: "일괄 비활성화",
  GQ5EVQ: "최소 하나 이상을 확인하세요",
  GUMdjP: "마지막 실행 상태",
  Gk0Mt5:
    "({name}) 알람 장치를 재설정하시겠습니까? 재설정 후에도 알람 규칙은 계속 모니터링됩니다.",
  GujK99:
    "나중에 알람 템플릿의 내용이 업데이트되면 적용 장치에도 동기화됩니다.",
  HN1dNJ: "모든 계정",
  IqkgWZ: "키워드",
  "Iwt/8W": "주석",
  "J0D5h+": "시작 시간",
  J9jPRL: "복사 성공",
  JJl2M9: "내보내기",
  JeJAmT: "이름 바꾸기",
  Jh62y5: "모든 장치",
  Jp7u8z: "",
  LWSLHa: "따뜻한 알림",
  Ls1X2Z: "처리됨",
  "LuP+H0": "설명",
  LwhdsE: "다중 선택 토글",
  MnTdIi: "트리거 수",
  MvGPdx:
    "({name}) 알람 템플릿을 활성화하시겠습니까? 활성화한 후 새 알람 장치가 템플릿을 적용할 수 있습니다.",
  N4np50: "최대 알림 수",
  NTanl8: "알람 템플릿 추가",
  NW8FV4: "장치 명령 상태",
  OsMncl: "켜지지 않음",
  "P/eul9": "아니요",
  P6YSaZ: "알람 기록",
  PgNsL5: "배포 중",
  "Py/5UG": "운영 중인 노드가 더 이상 존재하지 않습니다. 다시 운영해 주세요.",
  "Q2/NzC": "{num}개의 장치가 선택되었습니다",
  QHhMxE: "문자를 선택하세요",
  QV3pnn: "상태",
  "QavrS/": "규칙 이름",
  QwHI8Q: "쿼리 결과:",
  R2D5Dv: "생성 시간",
  R3TTCW: "알람 템플릿 편집",
  S57QRB: "필터링 기준",
  SGDlQ6: "총 {total}개 항목",
  T3CtvK: "범주 이름은 비워둘 수 없습니다",
  TDuPUp: "트리거됨",
  TqDOFU: "인증 코드를 자주 보내지 마세요!",
  U2DqqT: "회사 검색",
  UBbWUL: "템플릿을 선택하지 않았습니다",
  UFjZVV: "배포 상태",
  UUtqvk: "처리되지 않음",
  UcumBq: "경보 알림",
  UtE0dS: "작업",
  "Uu/nFu": "이 장치에 적용된 모든 알람 템플릿을 제거합니다",
  V0RiZp: "작업 성공",
  VR6zMp: "정말 비활성화하시겠습니까?",
  VRizgn: "휴대폰번호를 입력해주세요",
  ViVQNi: "역할",
  WeKYMe: "마지막 주문 시간",
  Wp6QLH:
    "({name}) 알람 규칙 재설정을 확인하시겠습니까? 재설정 후에도 알람 규칙이 계속 모니터링됩니다.",
  "WwRq+y": "알람 알림 개체를 추가하세요",
  "X/cNgA": "알림 삭제",
  XFEq9J: "템플릿 상태",
  XG2wHz: "배포 성공",
  XMBOec: "태그 제거",
  XeiAal: "삭제",
  XgmTAk: "장치 일련번호",
  YBAsWB: "그룹 명령",
  YpXN8m: "마지막 트리거 시간",
  ZETl7o: "알람 템플릿",
  ZMUuo8: "활성화하시겠습니까?",
  ZPSpaL: "알람 모듈 이름",
  ZUPzqr: "켜기",
  "Zvt+2g": "창고",
  aBleoN: "알람 템플릿 선택",
  "aN+DgN": "활성화 시간",
  aiBGBs: "삭제 성공",
  "arp+TQ": "50개 항목/페이지",
  "bE+h3K": "장치 상태",
  bOKDVF: "라디오 선택 전환",
  bqbDVw: "쿼리",
  cDZ00w: "보기",
  drCsUI: "회사",
  e8OyHO: "20개 항목/페이지",
  f7Dpbl: "템플릿을 다운로드하고 템플릿 프롬프트에 따라 콘텐츠를 개선하세요",
  fz2pkM: "이 노드는 삭제되었습니다",
  gU4eZD: "알람 관리",
  ggvI6Z: "모두 선택",
  gomg5W: "알림 비활성화",
  gzHM5l: "알람 해제 날짜",
  "hDx3/S": "이메일",
  hMboy7: "명령 상태 세부정보",
  iKomBu: "아직 분류가 없습니다",
  ieTzi7: "알람 템플릿 세부정보",
  ifGp4v: "2FA",
  iyOrrD: "100개 항목/페이지",
  j6IHvr: "세부정보 보기",
  jT6zKT: "장치 수",
  jdbKm7: "경보 알림 개체",
  jddlWH: "배포 실패",
  kCh5Jz: "힌트",
  kG2Etz: "온라인",
  khyRcw: "엑셀 파일을 선택하세요",
  kwOS33: "알림 활성화",
  l1fZNE: "모든 상자를 선택 취소할 수 없습니다",
  loTFGc: "이름 없음",
  m0Qdyj: "확인 실패",
  ma6S6y: "맞춤형 디스플레이",
  "mpeFt+": "알람 규칙",
  nH1F3p: "({name})의 현재 알람 규칙을 삭제하시겠습니까?",
  nJCPaY: "사용자는 바인딩된 이메일 주소가 없어 확인할 수 없습니다.",
  nUSeQB: "선택된 계정이 없습니다",
  nw8orn: "알린 사람 수",
  pBPyFt: "누비스 버전",
  "pV2t/S": "기본 정보",
  pcU9bM: "구성원 추가",
  q6qKtH: "쿼리 조건:",
  qUKj7E: "복사",
  "r0/TUu": "확인",
  "r2dEd/": "재설정",
  s9U9qn: "알람 설정",
  sOIerB: "활성화되지 않음",
  sZSyGZ: "활성화",
  srEpKw: "업로드 중",
  srpWCM: "표시해야 할 필드를 확인하고 드래그하여 정렬하세요",
  t2iHNJ: "업데이트",
  "tCh+iz": "알람 해제 시간",
  tLW3W3: "휴대폰번호",
  tokMPz: "예외 개체",
  "uoZwj+": "창조자",
  v04auv: "종료 시간",
  w8L9Kj: "경보 규칙 구성",
  wOHHSJ: "위로 이동",
  wQAiLI: "알림 재설정",
  xISm1t: "활성화",
  xUjLTE: "검색",
  y9NWzQ: "경보 장치 목록",
  yGWx2z: "매개변수 오류",
  yOMNOj: "예",
  yReEcE: "태그 선택",
  yXsHgv: "10개 항목/페이지",
  yb3AuG: "오프라인",
  ybGQQ3: "관련 결과 없음",
  "yiO/gL": "템플릿 목록",
  yxPDHk: "출시 상태",
  zH7h1q: "역사",
  "96Mzoq": "완료됨",
  ByhhM1: "조건",
  PcCooF: "알람 트리거 값",
  "z9+Z7p": "태그 선택",
  RUMaeu: "알람 규칙을 완전히 입력해 주세요",
  h7w4pz: "아직 데이터가 없습니다",
  nMMNa6: "이메일, SMS 또는 시스템을 통해 알려드리겠습니다.",
  "nOE0/j": "회사 및 회원 검색",
  q6WPYA:
    "선택한 장치에는 {num}개의 Nubis Free 버전이 포함되어 있으며 그룹 전송 명령이 불가능합니다.",
  "+CP3nr": "작업 선택",
  "+gbx50": "경보 조건",
  "+wet4N": "인증 코드 오류",
  "/BzHXM": "작성자를 선택하세요",
  "/SqqyP": "장치 일련번호를 입력하세요",
  "0YYUNG": "{num}개의 태그가 선택되었습니다",
  "1M03Dq": "일정 템플릿",
  "1SslIM": "응용 프로그램 닫기",
  "1gjtU2": "마지막 실행 시간",
  "1sj5Sj": "이 장치에 적용된 모든 일정 템플릿을 제거합니다",
  "2MYr1m": "로그인",
  "2l+gFk":
    "({name}) 일정 템플릿을 활성화하시겠습니까? 활성화한 후에는 장치가 템플릿을 참조할 수 있습니다.",
  "2opnVU": "실행 중",
  "2r/XUW": "이 태그에 의해 적용된 모든 일정 템플릿 제거",
  "3xlnbE": "명령 시간",
  "47GdDb": "닫기",
  "5ytYaf": "새 일정 템플릿",
  "65DvZ1": "입력 상한: 4",
  "6x6nu5": "실제 실행 시간",
  "8zN+hZ": "응용프로그램 실행",
  "9UZxwP": "인증 코드를 입력하세요",
  "9kkcTB": "일정 템플릿 삭제",
  "9ljNkr": "재전송",
  "A/eXwT": "이 라벨에 적용된 모든 알람 템플릿 제거",
  AyWMlZ: "예약된 작업 추가",
  BiPxfI: "일정 템플릿 추가",
  C6cGK1: "일정 템플릿 이름은 비워둘 수 없습니다.",
  EGvInA: "장비 경보 목록",
  Ft60hS: "누비스 장치",
  Gwj7xc: "기본값 복원",
  H15ECl: "입력 애플리케이션",
  "J3BW/8": "이메일로 받은 인증 코드를 입력하세요",
  KW8qOm: "템플릿 선택",
  LADN1a: "스케줄링 실행 상태",
  Lfia0v: "일정 설정",
  NDmD8V: "일정 템플릿({name})을 삭제하시겠습니까?",
  OVecAI: "성공",
  OwtOn5: "전체 상태",
  PTc6Gt: "예약 활성화",
  PaMvre: "알람 규칙 목록",
  PnYplH: "장비",
  RNaGVr: "작업 실패 목록",
  RWBRyt: "장비 분포도를 구축 중입니다",
  "RuFFf/":
    "({name}) 일정 템플릿을 비활성화하시겠습니까? 비활성화한 후에는 장치가 템플릿을 참조할 수 없습니다.",
  SPyEF8: "모드 선택",
  SwMBFl: "일정 템플릿 적용",
  TDSTTj: "일정 템플릿 선택",
  UMU42c: "장치 선택",
  Unvxiq: "계정 전환",
  WxPZOH: "{num}번 실행",
  WypzMq: "예약된 작업",
  X2m4ec: "일정 템플릿 비활성화",
  "YIgP+p": "장치 일정 목록",
  LNGTru: "장치 예약 실패 목록",
  YwEzx2: "표시해야 할 필드를 확인하세요",
  Z2B362: "연속",
  ZBDct6: "실패: {num}",
  ZHAjhZ: "입력 상한: 30",
  Zr9Dss: "실패",
  azDNha: "성공적으로 전송되었습니다",
  b5l2vN: "저장",
  b6y8Ai: "({name}) 일정을 비활성화하시겠습니까?",
  bYIKFB: "진행 중: {num}",
  "e/6XZC": "인증 코드를 받지 못하셨나요?",
  eAgY2G: "자회사 확장",
  fl7J8Y: "메시지",
  "gH+Az7": "예약 비활성화",
  gi4oTZ: "일정 템플릿 목록",
  gplM71: "매일",
  "hAd+eG": "장비 일정 달력",
  "hD7/Lu": "디스플레이",
  hYN7oM: "숨기기",
  hfn1Ux: "성공/전체",
  hkJXyi: "예약된 작업 구성",
  "hkR3E+": "보기 모드",
  hwlmeB: "대상 유형",
  iN7Lps: "루프 모드",
  iscUWH: "완료: {num}",
  "j/YGZ0": "지도",
  j6Hm96: "예약된 실행",
  jNxbTC: "인증 코드는 비워둘 수 없습니다.",
  js3tZs: "일정 템플릿 이름",
  k9dozc: "실행 시간",
  kUagYW: "일정 실행 내역",
  l7IiCY: "예약 상태",
  "lzP/we": "ORA 다운로드",
  m1h20o: "다음 일정 템플릿의 내용이 업데이트되면 적용 기기에도 동기화됩니다.",
  "mC2//O": "일정 달력 보기",
  mFIXSq: "장치 일련번호",
  mISQTh: "세부사항",
  nGubXb: "일정 템플릿 세부정보",
  nqPJwo: "태그용",
  oCogiy: "명령",
  oY0m24: "사용자",
  oirnwv: "일정 템플릿 활성화",
  ojz0Ke: "더 보기 >",
  oru5FY: "일정 템플릿 편집",
  "p+zOzc": "결과",
  peNVzr: "{num}주마다",
  pfGGi0:
    "현재 장치에 적용된 일정 템플릿을 제거하고 더 이상 실행하지 않습니다.",
  pielKO: "부팅 장치",
  pkYJKs: "실행 상태",
  qhC4wy: "기기 검색",
  rUHCoM: "장비 일정 관리",
  sb1vdX: "진행 중",
  u3dVQz: "매주",
  "urr92/": "배포자를 선택하세요",
  vovKL8: "응용프로그램 경로는 비워둘 수 없습니다",
  "wrU/Kc": "{num}일마다",
  ygAHaf: "전송 시간",
  zvaxmN: "일정 관리",
  "2ffDGT":
    "예약된 작업을 닫으시겠습니까? 닫은 후에는 장치가 일정 템플릿을 실행하지 않습니다.",
  "D//rZg": "일정 템플릿 적용을 삭제하시겠습니까?",
  E1GPl7: "소유자",
  EwTMGn: "({name}) 일정을 활성화하시겠습니까?",
  GpzsBd: "예약된 작업 열기",
  IM8kXz: "({name})의 애플리케이션을 삭제하시겠습니까?",
  KXqGQe: "일괄 활성화",
  NGe0Cs: "스케줄 실행 기록 삭제",
  SkK50H: "예약된 작업을 추가하세요",
  Trt6ju:
    "예약된 작업을 시작하시겠습니까? 시작한 후 장치는 예약된 작업을 실행해야 합니다.",
  UiVtQS: "일괄 닫기",
  "Z56D+X": "예약된 작업 닫기",
  aKxrop: "일정 템플릿 적용 삭제",
  miANEg:
    "({name}) 예약된 작업을 닫으시겠습니까? 닫은 후에는 기기가 예약된 작업을 실행하지 않습니다.",
  ngLF8L: "({name})의 스케줄 실행 기록을 삭제하시겠습니까?",
  nqPOJc:
    "예약된 작업({name})을 열겠습니까? 연 후에는 장치가 예약된 작업을 실행해야 합니다.",
  oV0gpL: "출시 예정일",
  xtHJEE: "선택된 기록이 없습니다",
  yifWnc: "예약 실행 기록을 삭제하시겠습니까?",
  "+/R6RX": "작업 상태",
  "35v5wD": "알람 기록을 재설정하시겠습니까?",
  "3QXG/d": "오라 버전",
  "5jpkHg": "온라인 상태",
  G4XFn6: "하드웨어 모델",
  Ko5CPO: "알람 기록을 초기화하시겠습니까?",
  ajVpLe: "정말 이 알람 기록을 삭제하시겠습니까?",
  dEXfrL: "장치 상태 간격",
  eCCa0L: "작업 유형",
  fr4nkj: "정말 알람 기록을 삭제하시겠습니까?",
  nzsNwZ: "장치 상태",
  qDba8m: "오프라인 장치 상태",
  rDRAr0: "운영 체제 버전",
  YeF1dY: "시간대",
  BC52ne: "무시됨",
  SbZhau: "부팅 작업에서는 부팅 장치를 지정해야 합니다",
  "lsLYU/": "최대 알림 수는 10을 초과할 수 없습니다.",
  "NM/lRq": "업로드 취소",
  "3qF993": "현재 회사에 속하지 않은 장치는 이전할 수 없습니다.",
  "6+iYA0": "일련번호",
  yc6ZUL: "Ora 마지막 업데이트 상태",
  UA7mv6: "Ora 마지막 업데이트 시간",
  "fOwU1/": "속하다",
  jNiwk6: "알람 장치({name})를 삭제하시겠습니까?",
  "lLa/D3": "적용 유형",
  "wk1c/l": "장치 그레이스케일 업데이트 기간(현지 시간)에 따라",
  "5+oaTO": "이미지 마지막 업데이트 상태",
  "6pDRb2": "유효한 비밀번호를 입력하세요",
  ANeFu6: "비밀번호 확인",
  GnzEo7: "이미지 마지막 업데이트 시간",
  s7NSze: "작업을 확인하기 전에 계정 비밀번호를 입력하세요",
  "9RNrDU": "프록시 장치인지 여부",
  "+TzicH": "상인",
  "/CxA3j": "하위 판매자 추가",
  "4c3uw8": "판매자 제거",
  "5Hy0Qx": "동일한 판매자에게 양도할 수 없습니다",
  BBpRbn: "이 판매자가 적용한 모든 알람 템플릿 제거",
  DADacD: "이 판매자가 적용한 모든 일정 템플릿 제거",
  G9WbnV: "상인용",
  S1QSWC: "하위 판매자 가져오기",
  TYAJpp: "{num}개의 판매자가 선택되었습니다",
  Ve9Ksw: "이전 상인",
  Wzv7kF: "판매자를 선택하세요",
  h7Yvwt: "교차 판매자",
  jAAXdQ: "장비 상인",
  "kr+7Iy": "판매자 검색",
  tFr3tb:
    "알람 템플릿({name})을 삭제하시겠습니까? 삭제 후에는 기기, 판매자 및 라벨에 의한 이 템플릿 적용이 동시에 취소됩니다.",
  uuRzdk: "판매자에게 귀속됨",
  vD5wnY:
    "속해 있는 판매자를 확인하는 것은 해당 판매자의 허가를 받았다는 의미입니다.",
  zyMKgy: "판매자 선택",
  RndUeh: "예상 실행 시간",
  gcHeN9:
    "OS 애플리케이션 이름을 입력하세요. 예: Windows:chrome 또는 Android:com.android.chrome",
  EM8lAi: "기기 업데이트 가능 기간(현지 시간)에 따름",
  "4Regzm": "판매자 목록",
  "i6kDf/":
    "선택한 장치에는 {num}개의 Nubis Free 버전이 포함되어 있으며 장치 명령을 사용할 수 없습니다.",
  o8tJYm: "장치 명령",
  "+74JfZ": "예: Device_000001_Gaoqiao Merchant_Android",
  "+CLSks": "2. 이 명명 규칙이 적용되는 장치 시스템 유형",
  "+GQdfc": "토큰 업데이트",
  "+m8vFq": "명명 규칙 세부정보",
  "0KH9Qi": "장치 시스템 유형",
  "0Z908D": "동일한 응용 프로그램의 버전은 하나만 선택할 수 있습니다.",
  "0bBO2n": "버전",
  "0iTEVO": "토큰 보기",
  "12LEcf": "({name}) 이 명명 규칙을 비활성화하시겠습니까?",
  "1PtjRr": "장치 이름",
  "2/LdaO": "구성 정보 저장",
  "2V19bd": "구성 파일 세부정보",
  "2jlHQB": "2. 회사 기본 명명 규칙",
  "3ZtPM3":
    "상점에서 명명 규칙을 설정하지 않은 경우 새 장치를 추가할 때 회사의 명명 규칙이 적용됩니다. 적용을 원하지 않으면 다음 규칙을 비활성화할 수 있습니다.",
  "3qgucc": "수동으로 시간대 설정",
  "5FboZ/": "유형",
  "5ZgUEM": "구성 템플릿 편집",
  "5d3yZi": "유효 시간",
  "5noX9X": "구성 파일 이름",
  "6Ty5/G": "성공적으로 게시되었습니다",
  "7NmXNy": "현재 프로그램 정보",
  "7PkBL6": "자동 업데이트 활성화",
  "7ip592": "1. 명명 규칙 이름",
  "88CuCZ":
    "3. 이 저장소에 등록된 장치의 이름 지정 방법을 만듭니다(장치 이름 자동 입력)",
  "8WYGi+": "정말로 복사하시겠습니까?",
  "8huAxo": "새 규칙 추가",
  "8pB1C7": "응용프로그램 추가",
  "8u3CYe": "명명 규칙 이름",
  "8zQ4So": "패키지 ID:",
  "96c3gX": "포맷",
  "9iKk2b": "시작 번호",
  AFZDo7: "설치 기록",
  B0WqD0: "1. 장치 업데이트 기간(현지 시간)",
  BqUpjt: "com.android.chrome과 같은 패키지 이름을 입력하세요.",
  "CM76+/":
    "({name}) 이 템플릿을 활성화하시겠습니까? 활성화한 후에는 장치가 이 템플릿을 참조할 수 있습니다.",
  CPTAAj: "자연수 증가",
  CqlH6G: "스토어 목록 적용",
  "D/Yid+": "활성화 여부",
  D2KnIQ: "연결된 저장소가 성공적으로 연결되었습니다",
  DpnauN: "시간",
  Fi4xFb: "Android 애플리케이션을 성공적으로 업로드했습니다",
  G9APSK: "명명 규칙 편집",
  GRfLaO: "응용 프로그램 이름",
  HDYjnT:
    "현재 선택한 애플리케이션 버전이 기존 애플리케이션보다 낮아서 애플리케이션 설치에 실패할 수 있습니다. 애플리케이션이 올바르게 선택되었는지 확인하세요. 더 낮은 버전의 애플리케이션을 설치해야 하는 경우 확인할 수 있습니다. 원래 프로그램을 삭제한 다음 설치하세요.",
  HOHQFs: "명명 규칙 이름은 비워둘 수 없습니다.",
  "HdxQ2/": "스토어 관련 구성 파일 및 명명 규칙",
  "I/k8FH": "해제",
  IyhhzI: "구성 파일 생성",
  Kj5TRg: "설치할 장치 수",
  "L4w/Vo": "최신 버전",
  MI3yI1: "{percentCompleted}% 업로드 중",
  MRe8Q9: "버전 번호:",
  NrEurQ: "Mbps 업로드",
  Nrx60r: "Mbps 다운로드",
  OCp4OD: "구성 파일 보기",
  PDFXBi: "지금 게시",
  PkLYZS: "장치 명명 규칙",
  PlNIQ9: "시스템 설정",
  "Q+0CDu": "명명 규칙 추가",
  Q5vbU5: "패키지 ID가 일치하지 않습니다",
  QpOtgZ: "상점 이름",
  R9TpN6: "예상 설치 시간",
  RY4VVr: "업로더",
  RyXQqJ: "업로드 시간",
  UfxykZ: "이유",
  Unr58u: "업데이트 시간",
  Uzdb6l: "장치 유형:",
  Vd3wZV: "전체",
  VqEr9u: "점포 수를 적용합니다",
  WdyIyo: "작동 시간",
  WfS4rv: "연산자:",
  "XLdI1+": "Wi-Fi 강도",
  XnimdQ: "윈도우",
  Ym4SPE: "해제 시간(장치 실행 시간) 선택",
  ZWN1C0: "({name}) 이 명명 규칙을 활성화하시겠습니까?",
  ZdO12B: "스토어 적용",
  ZtZ7Yw: "프로그램 이름",
  aHlr3k: "제거",
  akvGrq: "구성 규칙",
  aqQg0p: "지역",
  bMdSkq: "네트워크 속도 테스트 기록",
  batMBC: "템플릿({name})을 삭제하시겠습니까?",
  bsjenW: "명명 규칙 활성화",
  cX08hK: "선택된 데이터가 없습니다",
  cawvIS: "마지막 업데이트 시간",
  cijnrq: "장치가 설치되었습니다",
  d8xSfX: "버전 코드",
  dGBGbt: "모두",
  dRYBRc: "버전 번호: {버전}",
  "devicesList@1": "모든 장치 선택",
  "devicesList@2": "모든 장치 선택",
  eUNh5K: "설치할 장치",
  "ecTX+c": "프로그램 이름이 필요합니다",
  eeCxuz: "OS 유형",
  epaa3H: "명명 규칙 추가",
  evJP5c: "명명 규칙",
  fX0dsH: "버전:",
  "fje/m/": "템플릿 이름:",
  fq3WGG: "구성 파일 관리",
  gQ7kPU: "안드로이드",
  gnNjS5: "개인 장치 이름",
  gyHdsW: "구성 템플릿",
  "gyh+d1": "케이블 네트워크",
  hDmGQl: "버전 코드를 확인할지 여부",
  hqGPDw: "24시간 형식 활성화",
  hxy4wV: "분석 중",
  i5JzAA: "상태:",
  i5MLJc: "마지막 업데이트 시간: {lastUpdate}",
  ie9Iom: "구성 템플릿 보기",
  ifAmoA: "구성 파일 템플릿",
  imhWD8: "업로드 설정",
  iroVTo: "회사 설정",
  j2kqd8: "명명 규칙 삭제",
  j3QWSE: "자연수 증가의 시작 숫자는 양의 정수만 될 수 있습니다.",
  jKzbw6: "설정 변경",
  "jN5tO+": "버전 코드: {versionCode}",
  "jhfb/7": "성공적으로 저장되었습니다",
  k7dy8j: "관련 구성 파일",
  kH9MHe: "명명 규칙 비활성화",
  kkLQie: "관련 상점",
  "ksb/lB": "원본 프로그램을 삭제할지 여부",
  l0mW6t: "최신 업데이트 시간",
  mRHwkp:
    "({name}) 템플릿을 비활성화하시겠습니까? 비활성화한 후에는 기기가 템플릿을 참조할 수 없습니다.",
  "mYa6W/": "사용자 정의 텍스트",
  "mml+gT": "응용 프로그램 선택",
  mn0ceu: "중복된 구성 규칙이 있습니다. 조정하세요",
  n1yIyi: "설치 시간",
  nDwIwd: "게시됨",
  nLERtc: "Android 애플리케이션 업데이트",
  o9bMHL: "크기",
  oC6GBl: "안드로이드 애플리케이션",
  "oFt+cN": "네트워크 속도 테스트",
  ovdKZi: "장치 번호를 설치할 수 없습니다",
  "p/3Nn5": "모바일 네트워크",
  qS0aFJ: "응용 프로그램 관리",
  qUiH5y: "구성 규칙은 비워둘 수 없습니다",
  qjtl3b: "시스템 업데이트 활성화",
  "qqwM/t": "구성 파일",
  rdEPl7: "장치를 설치할 수 없습니다",
  rsAvN6: "프로그램 이름:",
  rw3uGa: "새 구성 템플릿",
  "s+aIlP": "상점 이름 검색",
  saeFbf: "파일",
  t8R6VW: "패키지 ID: {패키지}",
  tWcCoB: "속도 테스트 날짜",
  twpxdo: "Android 애플리케이션 업로드",
  "u/NB+Y": "패키지 ID",
  vDCwZ9: "파일 업로드",
  vLW90z: "명명 규칙({name})을 삭제하시겠습니까?",
  vr5TVT: "입력하세요",
  wiSRo9: "설치된 장치 수",
  "xE1H+X": "설정",
  xdjVt1: "템플릿 이름이 채워지지 않았습니다",
  xlNcvg: "최종 업데이트:",
  xrQzKh: "크롬 등 애플리케이션 이름을 입력하세요",
  xwYDb8: "버전 코드:",
  ydktLD: "구분 기호",
  zeMk2K: "초안",
  zok1hp: "C 슬롯",
  zrIs7T: "마지막 업데이트 시간",
  "a++4i0": "게시 시간은 24시간 이후여야 합니다.",
  "3JwoQQ": "업로드가 실패했으며 응용 프로그램이 이를 구문 분석할 수 없습니다.",
  "9Fvzl9": "일괄 릴리스",
  OiP4rW: "현재 상점과 연결된 구성 파일이 있습니다. 확인하세요.",
  b95U3r: "구성 파일 목록",
  nJetAr: "지원되지 않는 형식입니다.",
  lPA1qT: "이 구성은 특정 장치에만 적용됩니다.",
  oXfYag: "버전 코드가 이미 존재합니다. 다시 업로드하십시오.",
  "k+a7BC": "자동 업데이트 시간 수행",
  "/k2Fs5": "구성 명명 규칙",
  e2ys3T: "스토어 구성 세부 정보",
  yy7EDI: "업로드",
  "+cCXuw": "파일에서 이미지 선택",
  "0cZQXI": "패키지 ID로 추가",
  "0xm1Zu": "잠금 키 조합",
  "33bmiC": "상위 디렉터리가 존재하지 않습니다",
  "4UcMA+": "Wi-Fi 추가",
  "4ia8sI": "기능 제어",
  "4o167y": "사용자 정의 텍스트의 길이는 30자를 초과할 수 없습니다",
  "66awCH": "새로고침",
  "C+cw77": "배경화면 구성",
  E6G3sr: "키오스크 모드",
  "FQK+2G": "파일 동기화",
  FWlWJR: "상점 정보 보기",
  HI1PTY: "폴더 경로를 입력하세요",
  HNavdr: "회사 이름",
  JPIKnb: "홈 화면",
  MufYuw: "잠금 화면",
  NPjnPZ: "밝기",
  "Pdx/YD": "비밀번호",
  Pg5mqb: "가로 모드",
  QSjBm5: "파일이 존재하지 않습니다",
  UH1kCc: "추가",
  UduVZX: "파일 선택",
  Usn1oq: "세로 모드",
  "Ymq1/H": "장치 폴더 이름",
  YzG9Iw: "블랙리스트",
  ZK1d6f: "SSID",
  bGGvOS: "사진 선택",
  c8uKl6: "와이파이",
  dZlNkV: "구성 추가",
  dmEBpU: "파일 동기화 구성",
  foT1aq: "현재 업로드 진행 상황:",
  g5Pknn: "파일 크기가 제한을 초과했습니다",
  gltp3e: "Windows 알림 끄기",
  gweUAO: "USB 인터페이스 잠금",
  nxeBGd: "예:",
  o8HwKf: "파일 이름",
  rULuF3: "다음 네트워크 연결만 허용할지 여부",
  tIm58E: "중지",
  tR69qg: "Windows 표시 언어",
  tnYpSo: "탐지 요청이 성공적으로 전송되었습니다",
  xNeD5U: "취소됨",
  xiwfUp: "볼륨",
  znna6r: "상점 정보",
  "+UT6Us": "짐바브웨",
  "+cSl6d": "네덜란드",
  "+vx0UI": "솔로몬 제도",
  "+vz4Gy": "시에라리온",
  "/1g/gd": "키리바시",
  "/EzG+0": "몬트세랫",
  "/ZaEbq": "아이티",
  "07BMT/": "알제리",
  "0E6+/f": "괌",
  "14axoc": "포클랜드 제도",
  "1BFTBO": "쿠바",
  "1GLoiG": "조지아",
  "1Z3cpQ": "코트디부아르",
  "1qc1Bb": "라트비아",
  "217kis": "르완다",
  "2c/STs": "몰도바",
  "3B2kCX": "페로 제도",
  "3Nlsp9": "슬로바키아",
  "3a17nf": "쿡 제도",
  "41lx/9": "아프가니스탄",
  "4KMP9f": "콩고",
  "4obEtL": "토고",
  "5w+tOJ": "알바니아",
  "62Z8c1": "팔라우",
  "6JR/Y7": "아일랜드",
  "6LZPqX": "사모아",
  "6Mnz8p": "모리타니",
  "6NPwCy": "시리아",
  "6f8kym": "이라크",
  "6qdPnx": "튀니지",
  "7KZ6vz": "베네수엘라",
  "7hGupC": "리투아니아",
  "7hNQVL": "필리핀",
  "7p85Tc": "퀴라소",
  "8m5tda": "이집트",
  "8y7qAE": "중앙 아프리카 공화국",
  "98qFTO": "저지",
  "99fbLn": "우루과이",
  "9T1JPo": "몰타",
  AD5RPE: "적도 기니",
  AKnToQ: "차드",
  "AO/9GT": "핀란드",
  AYs4yh: "마다가스카르",
  Ai6HyC: "우간다",
  AksTq6: "앤티가 바부다",
  ArbweL: "요르단",
  AzRGCX: "독일",
  "B/oRh5": "미크로네시아 연방",
  BcJbbP: "카타르",
  Bm5GdP: "대만",
  MRbe2A: "대만",
  BwMY6I: "서사하라",
  BxT2qw: "토켈라우",
  C0YR5J: "투르크메니스탄",
  C2pikc: "남수단",
  C7RUR5: "나우루",
  CKu8W1: "니우에",
  CYSGlA: "에스토니아",
  "D/Hl19": "마르티니크",
  DPthJ5: "룩셈부르크",
  Dxf50E: "코모로",
  EMaGPN: "소말리아",
  "Eihfz+": "파키스탄",
  Eul4yJ: "이탈리아",
  F0BTvX: "레위니옹",
  FsQ2Ph: "북마리아나 제도",
  FzXhJn: "바티칸 시티",
  GRDGdf: "누벨칼레도니",
  "HF/NiY": "아르메니아",
  HN9EHr: "한국",
  HTqMY5: "루마니아",
  HZs8KL: "부르키나파소",
  I2RkrK: "캄보디아",
  I7Erl3: "모로코",
  IGBRed: "아제르바이잔",
  IPfyBg: "이란",
  IbG9YJ: "노퍽섬",
  "IrME/4": "마카오",
  XeQT0P: "마카오",
  J1oSvz: "미국령 버진아일랜드",
  JIPBj1: "자메이카",
  JIWrkV: "캐나다",
  JJhl02: "콩고 민주 공화국",
  JOJTuh: "코스타리카",
  JddSbX: "도미니카",
  L7PjzJ: "크리스마스섬",
  LShUE0: "부탄",
  "Le+IiI": "북마케도니아",
  LeMbDw: "잠비아",
  LfkgD6: "호주",
  Lszars: "미국",
  M16xFB: "브루나이",
  MMzrYK: "리히텐슈타인",
  MTVChl: "통가",
  MXueJK: "안도라",
  MYneOz: "지부티",
  MZwu6r: "허드 맥도널드 제도",
  MbV1M9: "말레이시아",
  MkBrsn: "파라과이",
  MwNlM3: "부룬디",
  MyB1Vf: "사우디아라비아",
  NcwUGt: "이스라엘",
  OZFYbQ: "바누아투",
  OZyB9b: "보스니아 헤르체고비나",
  Oc4oig: "볼리비아",
  OhEAqA: "그리스",
  Oql6Jb: "포르투갈",
  PB00mS: "왈리스 푸투나",
  PBGuz3: "폴란드",
  PIBLYF: "홍콩",
  "1ObLsW": "홍콩",
  PIHPBR: "세인트 마틴 (프랑스령)",
  PjOc8o: "벨라루스",
  "Q+FGAs": "아이슬란드",
  "Q5QY0+": "케이맨 제도",
  Q5U8nY: "아메리칸사모아",
  QA9U89: "영국령 인도양 지역",
  QRUdeg: "멕시코",
  QxRaqi: "덴마크",
  RfQSLo: "북한",
  RlB4rB: "사우스조지아 사우스샌드위치 제도",
  RsWzOr: "헝가리",
  RzKiE0: "푸에르토리코",
  SEJjjI: "남극",
  SLmrMX: "불가리아",
  T6qzNm: "라오스",
  Tb6AtC: "아랍에미리트",
  To4yI6: "감비아",
  TqXGpl: "벨리즈",
  UQHsPm: "카보베르데",
  UZmEHG: "몽골",
  Ulf4Sq: "인도",
  VCRq6v: "핏케언 제도",
  VIFtwp: "카메룬",
  VTEHKS: "기니비사우",
  VWg1hF: "스발바르 얀마옌",
  VhGXkw: "올란드 제도",
  W2fcGi: "수리남",
  W9gKgU: "세이셸",
  WAl9tj: "동티모르",
  "WH+mo5": "우즈베키스탄",
  WJAfY4: "투발루",
  WobBPP: "라이베리아",
  XfoqmV: "엘살바도르",
  XoOuKT: "카자흐스탄",
  YINkHp: "세르비아",
  YMjT8q: "싱가포르",
  "Z+fptr": "콜롬비아",
  ZHe4St: "인도네시아",
  ZRhaI4: "바베이도스",
  ZgLO7j: "레바논",
  a9nZYf: "부베섬",
  aNVBIV: "프랑스",
  afgUkt: "트리니다드 토바고",
  ahaefV: "중국",
  b8Yur0: "베냉",
  bCl9eg: "베트남",
  bKHwtk: "방글라데시",
  bQkGVT: "러시아 연방",
  "cio5m/": "뉴질랜드",
  "d+SgS7": "니카라과",
  d97FOT: "파푸아뉴기니",
  dUeWgE: "피지",
  dXFo2O: "노르웨이",
  dcfcTW: "생피에르 미클롱",
  dyBAW0: "세네갈",
  eNa9WG: "세인트 헬레나",
  eX9WT0: "산마리노",
  eiecNW: "레소토",
  eu7j6G: "몬테네그로",
  f6i4Ch: "도미니카 공화국",
  fSGNZz: "벨기에",
  fe4fox: "수단",
  fp4MWN: "일본",
  g44w8D: "영국",
  gIZauu: "과테말라",
  gb8v87: "터키",
  h70zPD: "스페인",
  hB6jsF: "키프로스",
  hBpMeF: "마셜 제도",
  hC0etv: "칠레",
  hLeEYi: "세인트빈센트 그레나딘",
  hrmyDn: "탄자니아",
  htLGF6: "보네르섬",
  htNRZG: "모나코",
  hy4yn7: "키르기스스탄",
  iJsE6u: "말리",
  iVyVIA: "건지섬",
  iYdC7o: "네팔",
  icfTwL: "스리랑카",
  icoYQF: "프랑스령 남방 및 남극 지역",
  ipoOkJ: "니제르",
  j2GbDK: "상투메 프린시페",
  "j83TV+": "맨섬",
  jHmcI7: "기니",
  jKdq05: "아루바",
  "jZLo+u": "예멘",
  kCwSgm: "스웨덴",
  lAVHXj: "가봉",
  lc0eVA: "생바르텔레미",
  ljBSDy: "바레인",
  mIgnTu: "버뮤다",
  mdbt1h: "그레나다",
  n1eYYR: "크로아티아",
  n6sdJi: "나이지리아",
  nU0AoJ: "모리셔스",
  nbVGOe: "가이아나",
  ncprFv: "팔레스타인",
  nfMTZ9: "리비아",
  "oC/YmL": "앙골라",
  oJA0AV: "우크라이나",
  ofe1Jv: "슬로베니아",
  ox0SUk: "에리트레아",
  pG9dnN: "프랑스령 기아나",
  pGsPfz: "타지키스탄",
  "prG89+": "신트마르턴",
  "qKL/I7": "에콰도르",
  qhRoDt: "체코",
  r0r576: "오스트리아",
  riK5Od: "마요트",
  "s/ZbGB": "지브롤터",
  sVaevR: "프랑스령 폴리네시아",
  sgg3ZA: "케냐",
  srKhxN: "바하마",
  ssKHGM: "그린란드",
  swmjZg: "태국",
  "tUisY+": "가나",
  u3ws3s: "남아프리카 공화국",
  u9cEKj: "세인트키츠 네비스",
  uPO36O: "미얀마",
  uY8iM9: "모잠비크",
  ufZlit: "파나마",
  ufyzs9: "세인트루시아",
  v8IwQb: "아르헨티나",
  vPS1uD: "페루",
  vTEjni: "말라위",
  vcSBZu: "브라질",
  vixhhG: "몰디브",
  "wL/u2o": "터크스 케이커스 제도",
  "wYCJ++": "에스와티니",
  "we/YPm": "오만",
  xFrFSm: "나미비아",
  xV0lln: "영국령 버진아일랜드",
  xepQSL: "코코스 제도",
  xk4ByO: "과들루프",
  xwICWz: "스위스",
  yC4n0v: "쿠웨이트",
  yKWAek: "앵귈라",
  yLlbwi: "보츠와나",
  zhs13i: "온두라스",
  zw39MM: "에티오피아",
  "+31PFz": "아시아/우루무치",
  "+6yBji": "아시아/방콕",
  "+CgfU2": "태평양/에파테",
  "+POdLR": "유럽/볼고그라드",
  "+VqRkg": "미국/켄터키/몬티첼로",
  "/+Dhy+": "미국/상파울루",
  "/D9zXZ": "대서양/레이캬비크",
  "/UGQnF": "미국/놈",
  "0DYv/B": "아프리카/나이로비",
  "0HnaGc": "태평양/콰잘레인",
  "0R8CQs": "유럽/부다페스트",
  "0xV9JO": "미국/아르헨티나/라리오하",
  "1H4FmE": "유럽/우즈호로드",
  "1mv3LM": "아시아/치타",
  "1pl9Su": "아프리카/트리폴리",
  "1sEPCz": "아시아/도쿄",
  "1ua619": "유럽/프라하",
  "23aBJh": "미국/덴버",
  "2DXZtH": "유럽/코펜하겐",
  "2OWj6s": "아시아/베이루트",
  "2WXSh8": "아시아/카라치",
  "2qYhi8": "아시아/홍콩",
  "2s/Mlc": "아시아/캄차카",
  "2zQAXL": "유럽/키시나우",
  "327IN3": "미국/야쿠타트",
  "339CIL": "미국/벨리즈",
  "3Lz3cq": "태평양/엔더버리",
  "40b51E": "미국/미클롱",
  "4AZ4gQ": "미국/아르헨티나/살타",
  "4D94K+": "남극/케이시",
  "4NXksL": "유럽/리스본",
  "4XF+Io": "미국/테구시갈파",
  "4l3qM7": "태평양/누메아",
  "4neOsl": "미국/덴마크샤운",
  "4wb1r/": "유럽/룩셈부르크",
  "5M8Wkq": "미국/아르헨티나/후후이",
  "5oeyFi": "미국/아르헨티나/리오갈레고스",
  "5xwaJJ": "태평양/푸나푸티",
  "6/dk2l": "유럽/심페로폴",
  "6Rz5js": "아프리카/엘아윤",
  "6XgRmz": "아시아/홉드",
  "6d5tvh": "미국/보아비스타",
  "6wYqzG": "태평양/웨이크",
  "71fHGN": "미국/가이아나",
  "7Q7WxK": "미국/과테말라",
  "7WBtG1": "태평양/마주로",
  "7euHXg": "태평양/부건빌",
  "7jiQ+M": "아시아/타이페이",
  "82GEmf": "태평양/나우루",
  "8DjTJi": "태평양/파카오포",
  "9Fhwtp": "아프리카/몬로비아",
  "9TfEAv": "아시아/다카",
  "9UC6g0": "아시아/마카오",
  "9xN38t": "아시아/리야드",
  A1qgI0: "미국/캄포그란데",
  A8Tpo2: "아프리카/카이로",
  ADtcg9: "미국/인디애나/피터스버그",
  AQnn4z: "아시아/카타르",
  AX2M6K: "아프리카/카사블랑카",
  ApEhaf: "남극/보스토크",
  "BsRS+L": "아프리카/라고스",
  "CIpc+3": "아시아/랑군",
  CJgAlM: "미국/아르헨티나/부에노스아이레스",
  CMi686: "유럽/사마라",
  CRI2Ve: "태평양/채텀",
  CezJKN: "미국/산티아고",
  "Cs/zIo": "태평양/마르키즈",
  CvKLCn: "태평양/통가타푸",
  CwyqPj: "아프리카/아크라",
  D1tmTQ: "미국/노스다코타/센터",
  D55vg4: "아프리카/튀니스",
  DAlYN5: "유럽/이스탄불",
  DCrzIX: "유럽/안도라",
  DDqHds: "아프리카/카르툼",
  DQsykN: "미국/하바나",
  DVZRDC: "유럽/오슬로",
  DcYI27: "아프리카/마푸토",
  "EGDZo+": "아시아/스레드네콜림스크",
  EcRGq9: "아시아/두바이",
  EgIxeE: "미국/자메이카",
  "EnTK+r": "미국/시카고",
  EqvKbF: "미국/쿠이아바",
  F0y8e9: "미국/로스앤젤레스",
  F465cE: "유럽/헬싱키",
  F6OWRn: "태평양/포트모르즈비",
  FDGDXD: "유럽/키예프",
  FEnpn4: "유럽/베를린",
  FeFqOa: "아시아/초이발산",
  "G0/1QH": "미국/파라마리보",
  "GHrEk+": "아시아/호치민",
  Gcuin4: "아시아/울란바토르",
  "H+kwCw": "아시아/브루나이",
  "H/TECz": "아시아/서울",
  H11GhT: "아시아/칸딕가",
  HD7dNh: "아시아/키질로르다",
  HDlqGj: "미국/아르헨티나/투쿠만",
  HSmzBV: "미국/아르헨티나/산루이스",
  I2fe6r: "아시아/헤브론",
  ID5HGa: "태평양/괌",
  "IRsI+H": "아시아/마카사르",
  IVs8gT: "인도양/모리셔스",
  "IYKKU/": "아시아/예레반",
  IYSP57: "미국/산타렝",
  JGg252: "아시아/딜리",
  "JJJ+wW": "태평양/왈리스",
  JTTFhT: "태평양/코스라에",
  KBQ98i: "유럽/소피아",
  L6RwvT: "미국/스코어스비순드",
  LFkBwb: "아시아/쿠알라룸푸르",
  LGJGKo: "미국/인디애나/위나맥",
  LepYst: "미국/아르헨티나/산후안",
  LrC3cb: "아프리카/요하네스버그",
  M74J18: "태평양/아피아",
  "MS/dmQ": "유럽/빌뉴스",
  MYvQtB: "태평양/폰페이",
  MhFcna: "아시아/악타우",
  MpIqyW: "아시아/노보시비르스크",
  "N69J/J": "미국/케이맨",
  N7RBEQ: "유럽/파리",
  "NLL9E/": "아시아/싱가포르",
  Nap8NB: "미국/라파스",
  NhLpaB: "아시아/가자",
  NwiC8y: "아시아/바쿠",
  OPz5aV: "유럽/바르샤바",
  "OSP/DU": "미국/아라구아이아나",
  "OoH/k4": "유럽/몰타",
  OqlGXK: "대서양/페로",
  OtFyGC: "유럽/자포리자",
  P9EyMh: "아시아/알마티",
  PRo9ZX: "미국/그랜드터크",
  Pbr43k: "태평양/감비에",
  PdnZvE: "미국/인디애나/녹스",
  Phhnuu: "태평양/과달카날",
  "PlA+93": "미국/앵커리지",
  "Q+QFi7": "미국/파나마",
  Q0Nwql: "미국/나소",
  Q2hC7E: "아시아/아나디리",
  RTFf0R: "아시아/타슈켄트",
  RVtTvI: "미국/보고타",
  RcUwWS: "유럽/티라나",
  Rfu8ru: "미국/주노",
  RzRPhx: "아시아/테헤란",
  SRDvbw: "인도양/크리스마스",
  SkSGFq: "미국/아순시온",
  SqYr66: "태평양/추크",
  T7X3nR: "미국/코스타리카",
  TnMEvg: "유럽/리가",
  TnQgWT: "인도양/코코스",
  UE61nU: "아시아/자카르타",
  UEbt0M: "유럽/아테네",
  UjOTtz: "유럽/모나코",
  VlcnXa: "대서양/아조레스",
  WICb5K: "아시아/마가단",
  "WJ+FQF": "아시아/트빌리시",
  WTSjw5: "태평양/파고파고",
  WUi6ng: "아시아/쿠칭",
  WX1P13: "남극/데이비스",
  Wb2LCw: "남극/로데라",
  Wg0kce: "미국/인디애나/빈센스",
  WhpVLY: "미국/과야킬",
  Wq4Z0k: "미국/벨렘",
  XK8hFK: "미국/리오브랑코",
  XLgiC3: "태평양/노퍽",
  XN4sjj: "아시아/사마르칸트",
  XuXXK5: "미국/헤시페",
  YOJC0Y: "미국/인디애나/마렝고",
  Yux40Y: "남극/팔머",
  "Z+d4VE": "유럽/암스테르담",
  ZOXOj5: "남극/모슨",
  "aKg/xg": "남극/트롤",
  "aqHEW/": "아프리카/알제",
  aqZ1dw: "태평양/갈라파고스",
  aylTTV: "미국/퀴라소",
  "b5+eh2": "아시아/바그다드",
  b5GT3E: "아프리카/비사우",
  bf8oMi: "태평양/크리스마스",
  bkKBAQ: "아시아/폰티아낙",
  c5lOtj: "아시아/블라디보스토크",
  cCvy0S: "미국/카라카스",
  ciyA6X: "아시아/마닐라",
  cl18LV: "아시아/우스트네라",
  d6W7pe: "유럽/모스크바",
  dw9A9j: "미국/아르헨티나/멘도사",
  e77Cv2: "아시아/야쿠츠크",
  e88zL2: "아시아/니코시아",
  eDz3Tw: "미국/아닥",
  eJqVsD: "유럽/지브롤터",
  "eR7v+R": "미국/노스다코타/뷰라",
  ekhdTj: "아시아/자야푸라",
  "f6G4/S": "태평양/오클랜드",
  f6r66H: "미국/메노미니",
  fJpD6E: "아프리카/은자메나",
  fqXfBN: "유럽/로마",
  "fxAR+x": "아시아/오랄",
  g2HLMh: "남극/쇼와",
  gU3Odo: "미국/뉴욕",
  "gibo/e": "유럽/비엔나",
  gln1VX: "미국/엘살바도르",
  guiUEK: "유럽/부쿠레슈티",
  gycX1L: "미국/노로냐",
  h5YZ1i: "유럽/브뤼셀",
  hI5EVU: "인도양/레위니옹",
  hKq7PN: "유럽/칼리닌그라드",
  hL3apR: "미국/리마",
  hZiOxa: "미국/푸에르토리코",
  hdgzx5: "태평양/이스터",
  hrq9xi: "유럽/민스크",
  iBXv4d: "미국/메틀라카틀라",
  inPmEU: "유럽/탈린",
  jRwF7m: "미국/피닉스",
  jaNloj: "미국/마세이오",
  jtTALf: "태평양/호놀룰루",
  k6R7DN: "미국/포르탈레자",
  kLf0tS: "미국/디트로이트",
  lAz3SQ: "아시아/비슈케크",
  lNijTx: "대서양/스탠리",
  m5vKwe: "아시아/콜카타",
  mXs7zw: "미국/싯카",
  mnvAEu: "미국/인디애나/텔시티",
  n8UW9y: "아시아/예카테린부르크",
  nYFNxR: "아시아/사할린",
  o5Rywj: "미국/아르헨티나/카타마르카",
  oYmVJJ: "아시아/크라스노야르스크",
  ocqIaV: "인도양/차고스",
  ocqwXs: "아시아/옴스크",
  okHgMB: "아시아/두샨베",
  pKp9LP: "미국/인디애나/베베이",
  pNrCwc: "미국/마나우스",
  pQ5zcx: "미국/아르헨티나/우수아이아",
  pcGYLU: "미국/툴레",
  pvDJax: "미국/바베이도스",
  "q5++81": "유럽/런던",
  q7mJWt: "미국/보이시",
  "qSxe/X": "유럽/취리히",
  rB9Ewl: "아시아/악토베",
  rIY0ZR: "인도양/몰디브",
  rZTr8Y: "미국/인디애나/인디애나폴리스",
  rhN321: "미국/누크",
  rslOL6: "태평양/타라와",
  rwZktH: "미국/아르헨티나/코르도바",
  s2obSj: "태평양/팔라우",
  s3GZlv: "미국/포트오브스페인",
  slYOe6: "미국/카이엔",
  szkWWk: "미국/바이아",
  t5CPbZ: "유럽/더블린",
  tHE78L: "미국/산토도밍고",
  tMDDnr: "미국/마나과",
  tUaF1F: "태평양/니우에",
  tlkIG3: "태평양/피지",
  "tw/bjJ": "아시아/노보쿠즈네츠크",
  u0TM9W: "미국/포르토프랭스",
  uMXTTe: "유럽/스톡홀름",
  uNiOLq: "아시아/예루살렘",
  "uOkO/r": "아시아/이르쿠츠크",
  "utbU0+": "아시아/아슈하바트",
  ux1XM2: "대서양/버뮤다",
  "v+arTX": "미국/에이루네페",
  vMATTy: "아시아/다마스쿠스",
  "vWWiU+": "아시아/평양",
  vbHpIo: "아프리카/빈트후크",
  vn9nKr: "미국/포르토벨료",
  vohVUs: "아시아/카불",
  vwtvCc: "대서양/카보베르데",
  vy4zY8: "아시아/콜롬보",
  w7kHCL: "대서양/마데이라",
  wDFHDz: "미국/마르티니크",
  "wbQai/": "대서양/사우스조지아",
  wrZg4b: "아시아/팀푸",
  xAcBeP: "태평양/타히티",
  xKA8d6: "남극/뒤몽뒤르빌",
  "xx+5iB": "미국/켄터키/루이빌",
  y79PlA: "아시아/암만",
  yaBGO1: "태평양/핏케언",
  yeltlL: "인도양/마에",
  ygabsP: "미국/노스다코타/뉴살렘",
  z6KEn9: "태평양/라로통가",
  z98zna: "인도양/케르겔렌",
  zWABd8: "유럽/베오그라드",
  zm3ZI2: "아시아/상하이",
  zwjmMl: "아시아/카트만두",
  "e5x+i6": "호주/로드하우",
  gAtxKw: "남극/맥쿼리",
  P5aTR8: "호주/호바트",
  "nFhe/c": "호주/커리",
  e6YJm8: "호주/멜버른",
  dmcxmV: "호주/시드니",
  jFnCUr: "호주/브로큰힐",
  i5MwAy: "호주/브리즈번",
  WyjEwT: "호주/린드먼",
  JuasJd: "호주/애들레이드",
  co8c88: "호주/다윈",
  qm4oIk: "호주/퍼스",
  "0LrMZs": "호주/유클라",
  "+E914Q": "프랑스어 (레위니옹)",
  "+FHEub": "중앙 아틀라스 타마지그트어 (아랍 문자)",
  "/AAqs8": "포르투갈어 (적도 기니)",
  "/BbMQN": "싱할라어",
  "/NVZFV": "포르투갈어 (앙골라)",
  "/V7bTl": "풀라어 (라틴 문자, 감비아)",
  "/YFnxw": "사호어",
  "/stiNv": "태국어",
  "019rDM": "포르투갈어 (포르투갈)",
  "01GXUP": "풀라어 (라틴 문자, 기니)",
  "0BWpf+": "일본어",
  "0CHkPh": "서프리지아어",
  "0D82eT": "크로아티아어 (보스니아 헤르체고비나)",
  "0fzUyn": "포르투갈어",
  "0mDCSY": "스페인어",
  "0rqbd/": "몰타어",
  "160k/R": "러시아어",
  "1BHQDP": "벵골어 (인도)",
  "1F0Uz0": "아랍어 (이라크)",
  "1J25kd": "보스니아어 (슬라브어)",
  "1RqABh": "리투아니아어",
  "1dv927": "말레이어 (브루나이)",
  "29JxAe": "영어 (영국)",
  "2LBIWM": "이누크티투트어",
  "2OXQzm": "덴마크어",
  "2atqiI": "오로모어",
  "2hRVBA": "세르비아어",
  "30RDW+": "아랍어 (카타르)",
  "3PyL86": "영어 (필리핀)",
  "3Rvul8": "티베트어 (인도)",
  "3ijo+p": "네덜란드어 (수리남)",
  "4+Zl7y": "스페인어 (엘살바도르)",
  "4Od9+t": "세르비아어 (슬라브어, 보스니아 헤르체고비나)",
  "4U3ZpB": "프랑스어 (아이티)",
  "4Xzh0/": "포르투갈어 (스위스)",
  "4eGD8c": "풀라어 (라틴 문자, 시에라리온)",
  "4fkP4F": "스페인어 (쿠바)",
  "4lbmZs": "스페인어 (필리핀)",
  "4v0pnb": "웨일스어",
  "51lnU8": "쾰른어",
  "5KynFd": "체코어",
  "5cyBop": "영어 (인도)",
  "5ff1Qr": "총가어",
  "5g+4ES": "한국어 (북한)",
  "5riLBC": "소말리어 (지부티)",
  "5vu2sQ": "우즈베크어",
  "5xPlEp": "중국어 (번체)",
  "62eqUV": "북루리어",
  "6AZb8G": "이누크티투트어 (교육 과정)",
  "6G/CAW": "벨기에어",
  "6am43/": "중앙 쿠르드어",
  "6ebNfH": "중국어 (간체, 홍콩 특별행정구)",
  "6gtes0": "중앙 아틀라스 타마지그트어",
  "6sur5u": "덴마크어 (그린란드)",
  "7Gt5UH": "산스크리트어",
  "7k8oo8": "독일어 (오스트리아)",
  "7wLEyk": "맹크스어",
  "7yHu97": "라트비아어",
  "8MDM0L": "타밀어 (스리랑카)",
  "8oEDHH": "프랑스어 (모로코)",
  "93yDUJ": "남부 사미어 (노르웨이)",
  "9cbhiA": "아랍어 (세계)",
  "9ftsGr": "영어 (말레이시아)",
  "9ltErv": "로만슈어",
  "9uEO2O": "아스투리아스어",
  AAf440: "세소토 사 레보아어",
  ALhR5U: "케추아어 (페루)",
  "AQfg7+": "프랑스어 (콩고 민주 공화국)",
  AahSYM: "우즈베크어 (아랍 문자)",
  AeHTyT: "영어 (홍콩 특별행정구)",
  "B+59h1": "몽골어 (전통 몽골 문자)",
  B8qZTI: "아르메니아어",
  B9ZGRE: "라오어",
  BFf5tN: "프랑스어 (캐나다)",
  BgGwdt: "베트남어",
  BpUgM5: "네덜란드어 (보네르, 신트외스타티우스 및 사바)",
  BtqqJK: "스페인어 (온두라스)",
  CBhHg6: "풀라어 (라틴 문자, 나이지리아)",
  CDbpEz: "아이슬란드어",
  CFRfr5: "종카어",
  CauPny: "카탈루냐어 (프랑스)",
  Ccf8zA: "스페인어 (우루과이)",
  DBHTS0: "영어 (호주)",
  DMjlMC: "독일어 (벨기에)",
  DW0c2K: "스페인어 (칠레)",
  DzWKvp: "조지아어",
  "EP6mL+": "마니푸리어",
  EREJay: "사미어 (룰레)",
  EeOqFb: "포르투갈어 (상투메 프린시페)",
  EzFn0W: "네덜란드어 (아루바)",
  F38yZH: "소말리어",
  "FHLC+T": "독일어 (리히텐슈타인)",
  Fxzz1N: "스웨덴어 (핀란드)",
  FzgpJw: "벵골어",
  G7wzBO: "아랍어 (아랍에미리트)",
  "GF/5qr": "타첼히트어",
  GGLJ5z: "코르시카어",
  GHtHh4: "마오리어",
  "GRMM/R": "알자스어 (프랑스)",
  "GZ+vSv": "시리아어",
  GnC74O: "티베트어",
  GqQl0h: "이탈리아어",
  GsOiFJ: "영어 (남아프리카 공화국)",
  Gwyv4n: "펀자브어",
  "H/OHWA": "필리핀어",
  H4fFDA: "북부 사미어",
  H73FDV: "위구르어",
  "H7jT/h": "알바니아어 (코소보)",
  HDDkEc: "줄루어",
  HVCuT9: "영어 (독일)",
  HZPa57: "스코틀랜드 게일어",
  "Hhe/Ef": "스페인어 (브라질)",
  Hj8GDj: "구자라트어",
  Hq92CJ: "하와이어",
  HqCNsI: "노르웨이어",
  "I/+zqv": "영어 (건지)",
  I42yCw: "영어 (캐나다)",
  IC7HXP: "티그리냐어",
  IDCrtf: "핀란드어",
  IEUJ0j: "독일어 (룩셈부르크)",
  "IR/BFt": "소말리어 (에티오피아)",
  ItGyiB: "칸나다어",
  Iz1WLp: "우르두어",
  J1rnrw: "슬로베니아어",
  J5rPWm: "스페인어 (에콰도르)",
  JPFRXM: "영어 (몰타)",
  JVK3dg: "독일어",
  JkretN: "영어 (핀란드)",
  Js4yYb: "풀라어",
  "Jsem/p": "모호크어",
  KDsjWJ: "표준 모로코 타마지그트어",
  "Kj/zcq": "프랑스어 (모나코)",
  LX0RZR: "풀라어 (아드람 문자)",
  Laghvq: "키냐르완다어",
  Ll0N3I: "체로키어",
  MESBkg: "코사어",
  MJQbru: "바시키르어",
  Mbp9v6: "아랍어 (시리아)",
  Mt9Ngn: "히브리어",
  N4oAho: "소토어",
  NLZIcM: "네덜란드어 (벨기에)",
  NObQUE: "아프리칸스어",
  "NV+8r2": "마푸체어",
  NVQG0j: "디베히어",
  Nevbjx: "풀라어 (라틴 문자, 모리타니)",
  NfTD2i: "스페인어 (베네수엘라)",
  NhbCYP: "발렌시아어 (스페인)",
  NtuQMz: "포르투갈어 (마카오 특별행정구)",
  "O/Bw0H": "세르비아어 (라틴 문자, 코소보)",
  OKUlj2: "헝가리어",
  OSMagZ: "프랑스어",
  Oju9iC: "몽골어",
  P23feN: "스페인어 (벨리즈)",
  "P91ei/": "타지크어",
  PE6jNM: "스페인어 (아르헨티나)",
  PO8fNg: "포르투갈어 (동티모르)",
  POQTzM: "프랑스어 (세네갈)",
  PSoXmh: "오리야어",
  Pa7aMt: "아랍어 (레바논)",
  Pl3tfG: "스웨덴어",
  PsNb95: "아일랜드어",
  Q8eBZk: "네덜란드어",
  QBwWZp: "오로모어 (케냐)",
  Qcitp4: "자와어",
  Ql51WU: "마라티어",
  R1VwTR: "바스크어",
  R325ks: "스페인어 (라틴 아메리카)",
  R34HBa: "아랍어 (오만)",
  RRmxSU: "케추아어",
  RTbzBi: "상부 소르브어",
  RWrQ2K: "아랍어 (알제리)",
  "RqsM+G": "스페인어 (니카라과)",
  SUF5bX: "영어 (오스트리아)",
  Sg9DRE: "프랑스어 (스위스)",
  SlWjJ2: "남부 사미어",
  T9IHrN: "룩셈부르크어",
  TQ7V9A: "아랍어 (모로코)",
  Tddnlb: "텔루구어",
  Tq0aui: "크메르어",
  UAHDtf: "말라얄람어",
  UGFi6Q: "아랍어 (요르단)",
  Uc1vOK: "알바니아어",
  "V+BaHn": "파슈토어",
  V223G2: "풀라어 (라틴 문자, 부르키나파소)",
  V2uMRt: "타밀어",
  VJbQAt: "스페인어 (파나마)",
  VKt1qn: "네팔어 (인도)",
  VuQRaN: "이탈리아어 (스위스)",
  W6zXNX: "스페인어 (도미니카 공화국)",
  WK7YIm: "아랍어 (예멘)",
  WQtbS0: "영어",
  WU7Urn: "터키어",
  WUUTG8: "투르크멘어",
  Wlr6BV: "카탈루냐어 (이탈리아)",
  XAmFMw: "크로아티아어",
  XNXAkr: "케추아어 (에콰도르)",
  XT8v2Z: "카탈루냐어",
  XjbxJQ: "아프리칸스어 (나미비아)",
  Xkmde4: "중국어 (간체, 마카오 특별행정구)",
  Xx527p: "북부 사미어 (스웨덴)",
  Y7CQhy: "스위스 독일어",
  Y8mZTh: "영어 (자메이카)",
  Y941O5: "슬로바키아어",
  YNjb1t: "페로어",
  Ygp3rn: "보스니아어",
  "Z/MVyq": "교회 슬라브어",
  ZCh9e6: "하부 소르브어",
  ZQtURc: "루마니아어 (몰도바)",
  ZjrmiJ: "쇼나어",
  "Zki/XJ": "카자흐어",
  a9U6ge: "콘월어",
  aO94Wj: "우르두어 (인도)",
  "aTZE+x": "카슈미르어 (데바나가리 문자)",
  aiXFTk: "풀라어 (라틴 문자, 가나)",
  bDNNJp: "말레이어 (인도네시아)",
  bLqBa4: "영어 (뉴질랜드)",
  bRIPjy: "영어 (이스라엘)",
  "bT+IsS": "말레이어 (싱가포르)",
  bVuD3F: "아랍어",
  bfp8tQ: "그린란드어",
  c3rP5p: "영어 (슬로베니아)",
  cJbw13: "중국어 (번체, 대만)",
  cQRIur: "영어 (싱가포르)",
  d5MtIX: "인도네시아어",
  dEIOuD: "폴란드어",
  dPzT2w: "브르타뉴어",
  drEx3O: "스와힐리어",
  e9Fovw: "파피아멘토어",
  eGmwHh: "영어 (스위스)",
  eSg76K: "영어 (지브롤터)",
  eSmbEf: "아일랜드어 (영국)",
  eWnJnC: "힌디어",
  efy66J: "체첸어",
  "f+NB92": "스페인어 (페루)",
  "f/8iNS": "풀라어 (라틴 문자, 카메룬)",
  "f5+iem": "스페인어 (멕시코)",
  f6Viji: "파슈토어 (파키스탄)",
  fkHabQ: "키체어",
  fv9aDa: "사미어 (이나리)",
  "gHco+M": "러시아어 (몰도바)",
  gOsLMk: "마다가스카르어",
  gWx9ey: "세르비아어 (라틴 문자, 몬테네그로)",
  gfmlPE: "영어 (아일랜드)",
  glnMAY: "타첼히트어 (라틴 문자)",
  gvaI7A: "소말리어 (케냐)",
  "h6q+Tn": "프로이센어",
  h9YX8r: "타밀어 (싱가포르)",
  "hEPDg/": "옥시탄어",
  hNSwvJ: "풀라어 (라틴 문자, 라이베리아)",
  hcX72z: "타밀어 (말레이시아)",
  hmzrxz: "북부 사미어 (핀란드)",
  hr7Bt0: "포르투갈어 (기니)",
  i4jvwu: "중국어",
  "i5/TH8": "스페인어 (적도 기니)",
  "iI431+": "영어 (네덜란드)",
  iKxsEO: "네팔어",
  iTiaM1: "과라니어",
  iXn58z: "아제르바이잔어 (슬라브 문자)",
  ifdXl3: "한국어",
  jG6ZfL: "독일어 (이탈리아)",
  jGXHMX: "세르비아어 (라틴 문자, 보스니아 헤르체고비나)",
  "jHvE/3": "은코어",
  joVZ4M: "아랍어 (이집트)",
  "k+bU6l": "네덜란드어 (신트마르턴)",
  k6RCbu: "포르투갈어 (룩셈부르크)",
  kW1ixl: "스와힐리어 (우간다)",
  l8f1rC: "카슈미르어",
  lGAoQJ: "스와힐리어 (탄자니아)",
  "lig/ia": "보도어",
  lwerC3: "스페인어 (미국)",
  "m+zQs1": "이보어",
  m421XM: "우크라이나어",
  "mP+2ZR": "영어 (트리니다드 토바고)",
  mQ30Fl: "영어 (포클랜드 제도)",
  mQPNAb: "신디어",
  mgFsmM: "영어 (덴마크)",
  "mkyn/R": "아랍어 (바레인)",
  mq4oU3: "영어 (저지섬)",
  mvxq4r: "갈리시아어",
  n86rIs: "키르기스어",
  naThLg: "그리스어",
  ncJAOw: "버마어",
  nfKkEe: "풀라어 (라틴 문자, 니제르)",
  nzfKPJ: "프랑스어 (카메룬)",
  "oCgi+u": "암하라어",
  "oh7xe+": "사미어 (룰레, 노르웨이)",
  oiHWuC: "독일어 (스위스)",
  ono6Zw: "스페인어 (과테말라)",
  ouSGKF: "사미어 (스콜트)",
  pJE11U: "세츠와나어 (보츠와나)",
  pVxDdM: "마잔다라니어",
  pcWfuB: "세츠와나어",
  pdfcvu: "프랑스어 (코트디부아르)",
  pjF6Nn: "소토어 (레소토)",
  pqIrOS: "아랍어 (튀니지)",
  q2N4yn: "세르비아어 (슬라브어)",
  qQDW8M: "프랑스어 (말리)",
  qRbMrx: "요루바어",
  qYdUNv: "중앙 아틀라스 타마지그트어 (티피나그 문자)",
  qu9gJ5: "아랍어 (리비아)",
  qwSYAN: "포르투갈어 (모잠비크)",
  r8ZWqf: "뉘노르스크 노르웨이어",
  rcixhA: "네덜란드어 (퀴라소)",
  rcmyN3: "페르시아어 (아프가니스탄)",
  rk5DA1: "영어 (벨기에)",
  sBC8AY: "신디어 (데바나가리 문자)",
  sHbxv8: "영어 (벨리즈)",
  sRuB7H: "말레이어",
  sl0qaQ: "아랍어 (쿠웨이트)",
  sliV2n: "스페인어 (파라과이)",
  syMU2g: "프랑스어 (벨기에)",
  tQJpug: "카탈루냐어 (사르데냐)",
  tQi27b: "콘카니어",
  tRgqyZ: "세르비아어 (슬라브어, 코소보)",
  tdrfAE: "영어 (카리브해)",
  u0KReQ: "이탈리아어 (바티칸 시국)",
  u61cWR: "스페인어 (콜롬비아)",
  u78bW4: "마케도니아어",
  uCI04p: "에스토니아어",
  uVRPPZ: "타타르어",
  ubfX8q: "영어 (짐바브웨)",
  uh1OQN: "월로프어",
  upv4s2: "포르투갈어 (카보베르데)",
  vSG3D5: "스페인어 (코스타리카)",
  viRRMu: "세르비아어 (슬라브어, 몬테네그로)",
  vo99Cy: "영어 (부룬디)",
  vuf8EY: "영어 (영국령 버진아일랜드)",
  vxR1y4: "하우사어",
  wVqnrV: "페르시아어",
  wra0CG: "스와힐리어 (콩고)",
  wtZRFn: "프리울리어",
  x0KMJr: "영어 (맨섬)",
  xXkK79: "몽골어 (전통 몽골 문자)",
  xeXtGt: "영어 (스웨덴)",
  xgB0JY: "아삼어",
  xoMuR7: "발저어",
  "xzWaZ/": "스페인어 (푸에르토리코)",
  "y//NHV": "아제르바이잔어",
  y7nOlh: "불가리아어",
  ydTOo2: "프랑스어 (룩셈부르크)",
  z0tSbC: "오세트어",
  z1VBi8: "루마니아어",
  zBWf5p: "인터링구아",
  zWU1xI: "스페인어 (볼리비아)",
  "05KCjo": "앱 아이콘：",
  "11uVJ/": "객체 수신",
  "1Qoc6t": "프로세스 이름:",
  "2JW1Pt": "이메일을 동시에 보낼지 여부를 선택하세요",
  "70JpVD": "프로세스 이름",
  "9AsSO/": "동시에 문자 메시지를 보낼지 여부를 선택하세요",
  "AH+jWQ": "윈도우 응용 프로그램",
  Axagls: "종료 시간을 선택하세요",
  FNIJXx: "스크롤 재생을 선택하세요",
  Fir0oq: "알림 유형을 선택하세요",
  G4qgGm: "모든 사용자",
  G5gg2V: "공지사항 제목이 필요합니다",
  IWPf2S: "공지 세부정보",
  IbWDVg: "버전 번호가 필요합니다",
  Km733q: "시작 시간을 선택하세요",
  L24ioQ: "제목",
  L80hmc: "공지사항 제목은 30자를 초과할 수 없습니다",
  NDjXUx: "파일을 배포하려면 명령을 입력하세요:",
  "Oex59+": "반품 목록",
  QHc9Qg: "공지 내용",
  QNomO6: "버전 번호를 입력하세요",
  Qpcx6F: "공지사항 내용이 필요합니다",
  RQyKsa: "플랫폼 발표",
  TiK9WZ: "프로세스 이름이 필요합니다",
  TvOGLc: "배포 파일 명령",
  UHuNzJ: "명령어를 입력하세요",
  WtPk7v: "동시에 SMS 보내기",
  XbIN5K: "프로그램 이름을 입력하세요",
  XeIKK7: "알림 센터",
  ZqioaF: "알림 제목",
  aGxRt2: "내용",
  cr1ymH: "전송 시간을 선택하세요",
  dY3og7: "앱 업로드 아이콘:",
  eFDqHN: "Windows 응용프로그램을 성공적으로 업로드했습니다",
  eSfTZf: "Windows 응용프로그램 업로드",
  "ghKe/+": "프로세스 이름",
  "h5yj+x": "프로세스 이름을 입력하세요",
  jAJbuk: "알림 공지",
  l36W55: "스크롤 재생",
  lqQKL4: "프로세스 이름으로 추가",
  mKKd1R: "수신자를 선택하세요",
  q9PHLT: "아직 발표가 없습니다",
  wYygRu: "발신자",
  xXdMar: "지정된 사용자",
  xx40g7: "공지 제목",
  yKFvYY: "동시에 이메일 보내기",
  yfhtRM: "첨부파일",
  z5L9EV: "Windows 응용프로그램 업데이트",
  "bhv+8O": "다운로드 중",
  xzmRTb: "지난 7일의 기록만 표시합니다",
  "yrR/HC": "설치 중",
  ibYzs0: "프로그램 이름: {name}",
  ivzCMK: "응용 프로그램을 구문 분석할 수 없습니다.",
  mJBhe1: "파일 동기화를 통해 최대 10개의 파일을 추가할 수 있습니다.",
  "6oXjFu": "업로드 형식이 잘못되었습니다",
  KetfTt: "최대 이미지 크기: 500KB",
  baNBmh: "이미지 크기는 500KB를 초과할 수 없습니다",
  tAjFr2: "이미지 형식: PNG, JPG, JPEG, BMP, GIF, SVG, WEBP",
  "3K02K/": "불완전한 Wi-Fi 구성",
  "5Cm9U3": "메시지 알림",
  "Y6Q+iJ": "WiFi 구성을 입력해주세요",
  tugHWJ: "공지사항 목록으로 돌아가기",
  "x/FhNQ": "알림 보기",
  "+GRUnH": "아시아/홉드",
  "+IL2pH": "아시아/리야드",
  "+J2Dyk": "아메리카/아순시온",
  "+Ny8AK": "아메리카/푸에르토리코",
  "+RWig5": "스페인어 (볼리비아)",
  "/2Wzyw": "아메리카/엘살바도르",
  "/rG/9z": "아메리카/퀴라소",
  "0AuprP": "태평양/통가타푸",
  "0X3KFO": "CPU 온도",
  "0vIw5o": "아메리카/보고타",
  "1YfhFP": "아시아/딜리",
  "2+A7qs": "남극/모슨",
  "2+ec6P": "아메리카/덴마크샤운",
  "2FPNxz": "아시아/두바이",
  "32RJkL": "아메리카/아르헨티나/산루이스",
  "33VS8L": "아메리카/마세이오",
  "36csPo": "유럽/취리히",
  "3KlQfs": "오스트레일리아/브리즈번",
  "3LAnU7": "대서양/페로제도",
  "3MaR6w": "유럽/탈린",
  "3NE037": "아시아/아슈하바트",
  "3svavz": "아메리카/미클롱",
  "42xSxy": "아시아/노보시비르스크",
  "4LAo5S": "아메리카/메틀라카틀라",
  "4Sw/d9": "아시아/크라스노야르스크",
  "4T/bEM": "아메리카/인디애나/베비",
  "4WaJo8": "아메리카/스코레스비순",
  "4Wgk5f": "유럽/안도라",
  "4ZRHuu": "대서양/사우스조지아",
  "4cXOI/": "아시아/예레반",
  "4jryq3": "아메리카/노스다코타/뉴세일럼",
  "4sqSH4": "아시아/칸디가",
  "564gFy": "아프리카/아크라",
  "6SQvm5": "아시아/폰티아낙",
  "6X6msx": "스토리지 사용량",
  "6xnHrJ": "유럽/베를린",
  "72KWoU": "오스트레일리아/시드니",
  "778/Xc": "아메리카/테구시갈파",
  "7JA1Vf": "아메리카/아르헨티나/멘도사",
  "7L+CJm": "유럽/헬싱키",
  "7geAkY": "아메리카/아르헨티나/부에노스아이레스",
  "7teo40": "태평양/추크",
  "87d7yX": "태평양/과달카날",
  "8Gi8qJ": "오스트레일리아/브로큰힐",
  "8eL/hC": "아시아/예루살렘",
  "8hJsOE": "아시아/방콕",
  "8qYKWy": "태평양/채텀",
  "8woxjy": "아시아/쿠알라룸푸르",
  "A3y/jB": "아메리카/아르헨티나/리오갈레고스",
  ACHtOA: "아시아/캄차카",
  AFZYEo: "아시아/브루나이",
  ALGNzc: "아시아/마가단",
  AWhHY3: "아메리카/리우브랑쿠",
  ApnLV0: "아시아/알마티",
  AqKGKn: "아시아/자카르타",
  As1lP0: "인도양/케르겔렌",
  "Aytpe/": "유럽/모나코",
  B6rikn: "아메리카/인디애나/인디애나폴리스",
  B9NkmN: "유럽/룩셈부르크",
  BXdJNy: "대서양/스탠리",
  BgYCgo: "남극/케이시",
  C21hEn: "유럽/베오그라드",
  C7HjWu: "유럽/암스테르담",
  CBkGYl: "아프리카/마푸토",
  CC9Jw3: "아시아/마카사르",
  CIImWq: "태평양/마주로",
  "CNMmH/": "아시아/야쿠츠크",
  CR8w2m: "아메리카/그랜드터크",
  CUsFOe: "아메리카/카옌",
  D2gXtv: "아메리카/메노미니",
  D4VBw5: "남극/뒤몽뒤르빌",
  DincSy: "오스트레일리아/로드하우",
  DoPuye: "아시아/다마스쿠스",
  "E/3oPZ": "아시아/마카오",
  E2NUw6: "아프리카/요하네스버그",
  EJA24j: "태평양/노퍽",
  EgGVTj: "태평양/엔더버리",
  EhPWhM: "아메리카/쿠이아바",
  EmxcJt: "아메리카/야쿠타트",
  Ewhh7n: "유럽/소피아",
  FXD37C: "아메리카/파나마",
  FsXquv: "아시아/평양",
  GIHcco: "아메리카/누크",
  GIwuGT: "유럽/브뤼셀",
  GNkv6K: "아프리카/엘아이운",
  "H8+X66": "아시아/칸디가",
  HDVqMh: "아메리카/아르헨티나/산후안",
  HEpXP8: "아메리카/덴버",
  HOEyDX: "아메리카/라파스",
  HS4Jyv: "유럽/우즈호로드",
  Hh1tUP: "아메리카/과야킬",
  HkGIFU: "남극/데이비스",
  HoSy6c: "태평양/콰잘레인",
  HuSwkp: "아시아/우스트네라",
  HzSbcD: "남극/트롤",
  I3bX6d: "아시아/우루무치",
  IBZBgD: "유럽/이스탄불",
  IHXrCK: "아메리카/로스앤젤레스",
  IKeroX: "아시아/자야푸라",
  ILjenb: "아메리카/인디애나/마렌고",
  IgbKn9: "아시아/호치민",
  InLlSF: "아메리카/파라마리보",
  J5iABC: "아시아/카라치",
  JHjx5l: "아메리카/앵커리지",
  "JURm/W": "남극/팔머",
  "Jc5/LG": "아시아/옴스크",
  JrjIBq: "아메리카/포르토프랭스",
  K9TF6H: "아시아/홍콩",
  KAKu2d: "태평양/누메아",
  KEr7iI: "태평양/팔라우",
  "KaS+yS": "아메리카/코스타리카",
  KyBesr: "태평양/라로통가",
  M3Bd2i: "태평양/피트케언",
  MAVhWe: "유럽/오슬로",
  MAWdwn: "아시아/콜롬보",
  McxhaP: "아메리카/벨리즈",
  MeSuny: "아메리카/바베이도스",
  MmTr9O: "아프리카/카이로",
  Mr4JiU: "인도양/차고스",
  MxWLCa: "태평양/마르키즈",
  NW4CG5: "아프리카/트리폴리",
  NWpmvK: "유럽/모스크바",
  Nd0dlz: "아메리카/아르헨티나/카타마르카",
  NhHERf: "아프리카/하르툼",
  O2VzkZ: "유럽/지브롤터",
  OEWR5m: "아메리카/헤시페",
  OPvCOV: "대서양/레이캬비크",
  OdITFl: "인도양/코코스",
  Oj7H2e: "유럽/몰타",
  OnT6Rq: "아메리카/아르헨티나/살타",
  P5ijks: "아시아/치타",
  P8Gz8g: "아시아/사마르칸트",
  P8fuMA: "태평양/아피아",
  PE4Jv1: "유럽/칼리닌그라드",
  "PHe5b/": "아메리카/상파울루",
  PQTASm: "아프리카/나이로비",
  PSTE5v: "아시아/테헤란",
  "Pr/HJJ": "아메리카/툴레",
  Q93ucv: "유럽/더블린",
  Q9eZjv: "아메리카/리마",
  QIrZ4x: "태평양/코스라이",
  QXW2mv: "아메리카/아르헨티나/투쿠만",
  QlNyHt: "아시아/서울",
  RWGdDh: "유럽/부쿠레슈티",
  RWhf30: "태평양/오클랜드",
  RbCEhx: "아메리카/켄터키/루이빌",
  RdB8rs: "아메리카/켄터키/몬티첼로",
  Ri5GFC: "유럽/볼고그라드",
  Rzjtg0: "남극/맥쿼리",
  "SB+r6t": "인도양/크리스마스섬",
  "SDmnE+": "아시아/암만",
  SO2rVX: "아프리카/빈트후크",
  TSIb1O: "아시아/베이루트",
  TVzP2K: "태평양/이스터섬",
  TmXGJf: "태평양/파고파고",
  Tp6vAo: "대서양/아소르스",
  "Tvk1/+": "아시아/바쿠",
  TxnfAW: "유럽/심페로폴",
  UU6RxP: "태평양/파카오포",
  "W+BF0N": "유럽/키이우",
  WF6jLL: "아시아/이르쿠츠크",
  WGbNbT: "유럽/로마",
  WH83gM: "오스트레일리아/유클라",
  WM9F6N: "유럽/부다페스트",
  WT4u2Q: "아프리카/비사우",
  Wd588a: "아메리카/주노",
  "X+krOQ": "유럽/런던",
  XG3VTC: "인도양/몰디브",
  XGLQKt: "인도양/모리셔스",
  XJz9XQ: "아메리카/시카고",
  XcLHzQ: "아메리카/산토도밍고",
  XgCqrC: "아시아/쿠칭",
  "Xs2qb/": "아시아/상하이",
  YUT4gj: "유럽/리스본",
  YZ2GGD: "아시아/싱가포르",
  "Ywxpi/": "인도양/마헤",
  Z0uRcM: "아시아/다카",
  ZKdJhk: "아메리카/보아비스타",
  ZZib2d: "오스트레일리아/호바트",
  Zjiy1h: "태평양/나우루",
  ZnA7Nz: "아시아/헤브론",
  a25tfu: "아시아/콜카타",
  a4hALt: "유럽/사마라",
  aIkFIc: "유럽/리가",
  aJXo8B: "아시아/사할린",
  an8KV9: "유럽/스톡홀름",
  "bPKD9+": "아메리카/바이아",
  bpugpH: "태평양/갈라파고스",
  bwibOg: "아메리카/인디애나/텔시티",
  bwxucD: "남극/로데라",
  byIMHD: "아메리카/인디애나/위나맥",
  cGo7xU: "유럽/빈",
  cL4iBR: "태평양/웨이크",
  cR6lQr: "아메리카/뉴욕",
  cY9R69: "아시아/양곤",
  "cdP+DQ": "메모리 부하",
  cfqioE: "아메리카/마르티니크",
  ckkIgb: "아메리카/산타렝",
  "d+p45H": "남극/오스트랄",
  "dD/ri/": "태평양/에파테",
  dVOPAi: "장치 오프라인 모니터링",
  dmQidl: "태평양/월리스",
  dnhrx5: "유럽/아테네",
  dsc2e1: "아메리카/캄푸그란지",
  dwtkZ7: "대서양/카보베르데",
  e7x56t: "아메리카/에이루네페",
  eCaCt4: "유럽/코펜하겐",
  eJ850A: "아메리카/카라카스",
  eUPrSB: "아메리카/아르헨티나/코르도바",
  "eiH+8b": "아프리카/은자메나",
  esrASO: "아메리카/마나우스",
  "f/kdJq": "아시아/두샨베",
  f2wvqe: "아시아/크질로르다",
  fRTjpp: "아메리카/포트오브스페인",
  felOXC: "유럽/민스크",
  "fr++q+": "아메리카/노스다코타/센터",
  fwXmSX: "인도양/레위니옹",
  g8yytK: "읽음",
  g9Ro8s: "아시아/팀푸",
  gCnWv3: "아메리카/과테말라",
  "gWP+OK": "아메리카/포르토벨류",
  gY9Idz: "알림 내용",
  hMJvQy: "아시아/악퇴베",
  hMvFT8: "태평양/피지",
  i9kfO3: "오스트레일리아/퍼스",
  ia2KGW: "오스트레일리아/린데만",
  iemojj: "아메리카/인디애나/피터스버그",
  iktlFx: "아프리카/라고스",
  ioR1tU: "오스트레일리아/멜버른",
  irTGxZ: "아메리카/나소",
  iuG5L2: "태평양/푸나푸티",
  jArote: "아시아/초이발산",
  jGg3Qb: "대서양/버뮤다",
  "kPnKK/": "태평양/타라와",
  kQfkBY: "태평양/니우에",
  kX80z5: "아프리카/카사블랑카",
  kb4vnt: "아시아/트빌리시",
  kibwvT: "아메리카/아라구아이나",
  klPlFN: "대서양/마데이라",
  ktaxSw: "읽지 않음",
  kzL66g: "아메리카/싯카",
  l0DTVX: "유럽/키시너우",
  l3HZXk: "아메리카/아르헨티나/후후이",
  lUObgG: "아시아/노보쿠즈네츠크",
  "lY+G1f": "유럽/자포리자",
  ldw5JF: "아메리카/하바나",
  ldz3Qp: "아메리카/놈",
  "luv+ak": "남극/쇼와",
  m372k4: "아시아/악타우",
  mC90qt: "아메리카/페르난두지노로냐",
  maWrSV: "아시아/카타르",
  mpmcYh: "아메리카/자메이카",
  mzw9vO: "아시아/블라디보스토크",
  nFRGgT: "아시아/니코시아",
  nG6bDa: "태평양/폰페이",
  nNIaxy: "오스트레일리아/커리",
  "nTx/do": "아프리카/몬로비아",
  ndfOI1: "아시아/타슈켄트",
  nfV4cd: "태평양/포트모르즈비",
  nt7Sni: "아메리카/피닉스",
  "oNgMl/": "유럽/바르샤바",
  ox9xcC: "아시아/울란바토르",
  "p/Y+A9": "아시아/오랄",
  p60kqM: "아메리카/인디애나/녹스",
  "pDAAq+": "태평양/크리스마스섬",
  "pH7u/B": "유럽/프라하",
  pctdGN: "태평양/타히티",
  pkQvvT: "아시아/가자",
  qZesUE: "태평양/부건빌",
  qm1rPH: "아메리카/아닥",
  qrxb3P: "아메리카/마나과",
  qyspJO: "아시아/바그다드",
  rB8hza: "아메리카/보이시",
  rDnYpj: "아메리카/디트로이트",
  "rSU+yK": "유럽/티라나",
  rhrAj5: "아시아/마닐라",
  sCbQzB: "태평양/괌",
  ssEhAp: "오스트레일리아/다윈",
  tGy5jw: "아시아/비슈케크",
  tb5CXr: "유럽/파리",
  u8OEeb: "아시아/아나디르",
  umaIEg: "아메리카/아르헨티나/우수아이아",
  "uq/hF0": "아시아/도쿄",
  v1R8a6: "아메리카/가이아나",
  v9QImt: "아시아/카불",
  vvPXpH: "아시아/카트만두",
  w6MqYv: "아메리카/벨렝",
  "wHl/4A": "오스트레일리아/애들레이드",
  wQ6hxa: "아프리카/튀니스",
  wTov5v: "아메리카/포르탈레자",
  wu6z2j: "태평양/감비에",
  xC5dF9: "아프리카/알제",
  xV1AHg: "아시아/예카테린부르크",
  xV72W5: "아메리카/산티아고",
  "xefyX+": "아메리카/노스다코타/뷰라",
  yBB7Af: "아메리카/아르헨티나/라리오하",
  yjTwMp: "아시아/타이베이",
  yk6eIX: "태평양/호놀룰루",
  z4BN1R: "아메리카/케이맨",
  zMTRSM: "CPU 부하",
  zOIpOr: "아메리카/인디애나/빈센스",
  zooIwl: "유럽/빌뉴스",
  "/+bsEl": "아메리카/몬테레이",
  "/Gtqfz": "아메리카/메리다",
  "22S38U": "아메리카/아티코칸",
  "3TyuhP": "아메리카/오지나가",
  "3nz5UA": "아프리카/아비장",
  "5LGVs8": "아메리카/이누빅",
  "5hwp3A": "아메리카/위니펙",
  "75rZvt": "아메리카/포트넬슨",
  B1cpxi: "아메리카/바이아반데라스",
  DB1i32: "아메리카/치와와",
  EjYbG7: "대서양/카나리아",
  JJlhYG: "아메리카/멍크턴",
  JK7opY: "아메리카/레이니리버",
  JMiQE7: "아메리카/스위프트커런트",
  JNgj9q: "아메리카/밴쿠버",
  LQs9br: "아메리카/크레스톤",
  TV0vfT: "아메리카/에르모시요",
  TtsBNI: "아메리카/산타이사벨",
  "V/ychw": "아메리카/세인트존스",
  V3RDY8: "아메리카/케임브리지베이",
  WrrSc3: "유럽/마드리드",
  XAJf4I: "아메리카/옐로우 칼",
  Xf2rFn: "아메리카/마사틀란",
  "YIziP+": "아메리카/랭킨_인렛",
  Zw6GOE: "아메리카/레지나",
  cvhrwM: "아메리카/팡니르퉁",
  d4TeTf: "아메리카/화이트호스",
  dS4Q9B: "아메리카/에드먼튼",
  dXgU6w: "아메리카/마타모로스",
  damxMJ: "아메리카/니피곤",
  hrTtyK: "아메리카/도슨_크릭",
  i7y8PO: "아프리카/세우타",
  mYnwj6: "아메리카/이칼루이트",
  mZSYZK: "아메리카/칸쿤",
  n4UQqL: "아메리카/도슨",
  pIep8S: "아메리카/멕시코_시티",
  pZHBxH: "아메리카/레졸루트",
  puzgCP: "아메리카/토론토",
  sf6FE5: "아메리카/글레이스_베이",
  trLh1J: "아메리카/티후아나",
  vmXV5r: "아메리카/블랑-사블론",
  x062Q4: "아메리카/핼리팩스",
  x5t5ol: "아메리카/썬더_베이",
  x8MKpa: "아메리카/구스_베이",
  qhku2P: "(Windows 7은 아직 지원되지 않습니다)",
  LjaYAu: "(설정을 적용한 후 장치가 자동으로 다시 시작됩니다.)",
  SsOQaU: "Android 기기 경로를 설정해야 합니다",
  ftJgyV: "장치를 확인해야 합니다",
  tp71Dv: "Windows 장치 경로를 설정해야 합니다",
  "+x/2kt": "장치 규칙",
  "781mpm": "3. 회사 기본 명명 규칙",
  EJYMZz:
    "닫은 후 Ora의 새 버전을 다운로드하여 직접 설치하거나 장치 명령인 Ora update를 통해 수동으로 업데이트할 수 있습니다.",
  QWNGGT: "장치 수량",
  QkSHo2:
    "자동 업데이트를 끈 후 장치의 Ora 버전 차이로 인해 일부 기능을 사용하지 못할 수 있습니다.",
  RFear4: "2. 장치 업데이트 기간(현지 시간)",
  VUYwkz: "응용 프로그램을 선택하세요",
  Z8Wkvb:
    "켜고 나면 Ora는 새 버전이 있으면 자동으로 다운로드하고 업데이트합니다.",
  bc4BgP: "또는 마지막 온라인 시간",
  c5daOt: "매장 수 ({num})",
  qDHqff: "자동으로 다시 시작",
  zbqD5q: "값",
  FtTdh0: "1. {ora}가 자동으로 업데이트됩니다.",
  Em0SLE: "다시 시작",
  Gvm3Ry:
    "({name})의 {appName}을(를) 다시 시작하시겠습니까? 다시 시작한 후에도 응용 프로그램 모니터링이 계속됩니다.",
  Ixi8kg: "다시 시작 알림",
  bbMhTk: "다시 시작하시겠습니까?",
  "99tjyG": "IP",
  "9a/nvJ": "작업 결과",
  BdDDD0: "장치 로그",
  MbqxKj: "템플릿 이름",
  OjLqmy: "알 수 없음",
  V6d4dz: "작업 세부 정보",
  "hD/l+2": "작업 유형",
  "s+OQvW": "연산자",
  yc8eep: "결과 선택",
  "/5RjKG": "token 실패",
  "0nwYmb": "모든 알림 유형",
  "ZC7J/S": "알림 유형",
  pm5kAg: "자세한 내용은",
  y8e4w8: "장치를 다시 시작한 후에만 적용됩니다.",
  vjxfR4: "(exe 설치 프로그램, msi 파일)",
  "8DORrA": "USB 포트",
  AFx0WP: "검색 유형",
  GyqBiS: "정보 인쇄",
  L3HWwz: "장치 설명",
  OuXnTb: "이 USB 포트를 재설정하시겠습니까?",
  "QZM++f": "프린터를 재설정하시겠습니까?",
  RCjVsb: "장치 ID",
  RJpihQ: "이 USB 포트를 비활성화하시겠습니까?",
  adMZWx: "주변 장치 추가",
  j3iWkN: "프린터를 반복할 수 없습니다",
  kL3ndq: "이 프린터를 제거하시겠습니까?",
  r8lAlx: "주변 장치 관리",
  wIFJtf: "연결되지 않음",
  zKsJJS: "이 USB 포트를 활성화하시겠습니까?",
  "zY36V+": "연결됨",
  "2Rco7+": "업로드 시간:",
  "5JrKIs": "선택한 릴리스 시간에 기능 배포가 예약되었습니다.",
  E62yo0: "함수 배포에 실패했습니다. 다시 시도합니다.",
  HI9nIp: "파일 제거",
  IX5jed: "구성 파일 배포 상태",
  Mxw3XE: "bat 파일의 이름이 install 또는 uninstall이 아닙니다",
  "N3h+Aq": "함수 배포에 실패했습니다",
  N9kr00: "전송 후 앱 제거",
  "OY+bYK": "확인, 다시 표시하지 마세요",
  PZD5BD:
    "[{name}] 구성 파일에서 이 프로젝트를 사용 중이므로 삭제할 수 없습니다. 프로젝트를 삭제하려면 구성 파일에서 제거하세요.",
  Pzsa4g: "함수 배포가 준비되었습니다",
  RzXkm3: "블랙리스트 활성화됨",
  SzN0Xf: "장치 소유자 제거",
  VvutjQ: "함수",
  XPoLPc: "함수 배포가 수신되었으며 곧 처리될 예정입니다.",
  Xsx53E: "이 파일을 제거하시겠습니까?",
  c7ABGP: "함수 배포가 Ora의 응답을 기다리고 있습니다.",
  d6mNdO: "허용 목록 활성화됨",
  f9tP6e: "이 Windows 애플리케이션을 제거하시겠습니까?",
  hmCei2: "앱 제거 후 삭제",
  ii1TCF: "(압축 패키지의 bat 파일 이름을 install 또는 uninstall로 지정하세요)",
  mmGD7U: "함수 배포가 진행 중입니다.",
  uL4MGN: "이 Android 애플리케이션을 제거하시겠습니까?",
  wzPSgE: "블랙리스트/화이트리스트",
  xAk1ic: "기능이 성공적으로 배포되었습니다",
  yWzW01: "(exe 설치 프로그램, msi 파일, zip 압축 패키지)",
  yvnu2T: "구성 템플릿 이름",
  "CqT/5i": "이 파일은 공유되었습니다. 삭제하시겠습니까?",
  wboZY3: "보고 시간",
  "6kNt8v": "다음 시간",
  Rkh3mc: "마지막 시간",
  "+/nbWD": "다음 변경 가능 시간 {time}",
  "1ULJr+": "단일 애플리케이션 모드",
  CxuMXm: "애플리케이션을 추가해야 합니다",
  Gp3iu0: "로컬 배경화면 업로드",
  M0GExq: "기기에 이미 앱이 있는 경우, 기존 버전을 제거하고 다시 설치하십시오",
  OYWCEU: "로컬 애플리케이션 업로드",
  PyHYs3: "VNC 연결 종료",
  QZCAIP: "애플리케이션 ID",
  "X+8ega": "키오스크 모드 선택",
  "bLP2/B": "설정 애플리케이션 상태 확인",
  bneXBI: "프롬프트 변경",
  czLSET: "애플리케이션 수동 추가",
  eg9Cwk: "현재 위치 회사에서",
  f8ijF3: "명령이 발급됨",
  i8wqAy: "로컬 애플리케이션 업로드",
  oiRBSj: "확인 후 기기에 새 설정이 적용됩니다. 적용하시겠습니까?",
  "qG2/EZ": "로컬 파일 업로드",
  "qH+vs7": "허용 목록",
  qTgFpp: "계정이 속한 회사의 계정",
  qwHBkg: "설정 변경 기록 없음, 모든 기기에서 기본 설정 사용",
  sB85Wu: "로컬 업로드",
  uqEE8V: "이 구성은 Android Ora 2.14.25에만 적용됩니다.",
  vtUGfp: "회사 기본 명명 규칙",
  QgHuyM: "매장 명명 규칙",
  "+Bas2b": "재생 시간: {duration}",
  "+a6DnG": "검토 중",
  "/CFd+q": "열림",
  "0JQoTX": "검토 실패",
  "0Ru5zG": "크기: {size}",
  "0UhE3z": "재생 상태",
  "0btyN9": "재생 시간:",
  "1/U2kj": "동영상",
  "1qoi3T": "이미지",
  "3HqLlX": "새 콘텐츠",
  "4jU7ke": "콘텐츠 플레이어 시작",
  "4nG/GN": "콘텐츠 이름",
  "5RR9aM": "일괄 일시 정지",
  "5XSNyG": "자료 업로드 완료",
  "6K/a0B": "일시 중지",
  "6wAcmz": "시간을 선택하세요",
  "7M1nFY": "템플릿 {name}을(를) 삭제하시겠습니까?",
  "7OW60G": "선택한 시간 지우기",
  "7Ouq4k": "순서: {sort}",
  "7cAtfM": "시간",
  "7wofGo": "애플리케이션",
  "9c8SPP": "크기",
  BhWZJo: "리소스 이름",
  C55Kjj: "재생 콘텐츠",
  "D+32Ow": "리소스 관리 센터",
  EBMdAL: "생성 완료",
  ECm6hH: "이 리소스({name})를 삭제하시겠습니까?",
  "ELFG/t": "기기 검색",
  IP9Kbk: "이미지는 다음 크기를 초과할 수 없습니다. 15MB",
  Ie9WHB: "자료 업로드",
  KOVFgK: "검토 대기 중",
  "Lqca+c": "플레이어 전환",
  MDACCo: "재생 성공",
  MWJG8I: "이름: {name}",
  "Ut8+i2": "승인됨",
  "Xi/+KE": "시간 슬롯 추가",
  YuZxve: "콘텐츠 선택",
  bKLb1C: "재생",
  bYujGa: "템플릿 생성",
  fFaC3Z: "재생 시간",
  gVXoXc: "콘텐츠 관리",
  i9lOCU: "선택하신 시작 날짜가 오늘보다 이전입니다",
  iHQiQV: "일괄 재생",
  iJIOBp: "파싱 중 실패",
  "iRR+fJ": "debugInfo",
  l9XE8F: "통과",
  lchpP8: "적용 성공",
  m8CFrl: "새 템플릿 만들기",
  nbp4U6: "콘텐츠 템플릿 목록",
  oUgWVb: "유형: {type}",
  "p/EHrl": "최대 비디오 크기는 10GB를 초과할 수 없습니다.",
  qx5UwR: "장치를 선택하세요.",
  rBWtYz: "최근 변경 시간",
  rnpMD3: "끄기",
  sux9FA: "최소 입력 제한: 1",
  tRm3bw: "일시 중지 성공",
  uhTa0i: "미리보기",
  w1cMGO: "종료일",
  ztKQno: "기간",
  J3dxzb:
    "Nubis는 현재 JPEG 및 PNG 이미지 형식을 지원합니다. 비디오는 H.264 코덱을 사용하여 인코딩해야 합니다. 지원되는 파일 형식에는 MPEG-4 및 MOV가 있습니다. 코덱은 빠른 전송을 위해 데이터를 압축하고 수신된 데이터를 원래 형식으로 압축 해제하는 소프트웨어 또는 하드웨어입니다. H.264 코덱은 비디오 콘텐츠의 녹화, 압축 및 배포에 일반적으로 사용됩니다. 비디오 파일 형식에는 하나 이상의 코덱이 포함될 수 있습니다. MOV 또는 MPEG-4 비디오 파일이 검토에 실패하는 경우, 비디오 인코딩에 사용된 코덱이 H.264인지 확인하십시오.",
  "M5Vtr/": "템플릿 편집",
  b1xi4S: "템플릿 미리보기",
  kNhfaL: "템플릿({name})을 삭제하시겠습니까?",
  kqgd4D: "실행 시간을 하나 이상 추가하십시오.",
  "36pf2y": "콘텐츠 기록",
  "3izvEF": "파일 선택",
  "9mG+jv": "파일 크기가 사용 가능한 공간을 초과합니다",
  AlFkwq: "설치된 기기 수",
  C8ZuKU: "이미지 너비",
  E0Czos: "이미지 높이",
  I73XLQ: "이미지 Y축",
  JbroVc: "Nubis Cast",
  MMqJtu: "이미지 또는 비디오를 선택해야 합니다",
  "Pv/1oy": "콘텐츠 표시",
  Rrwy85: "제작자",
  T8Y38H: "이미지 파일 (*.jpg/*.png)",
  VJ7wHx: "설치할 기기 수",
  WI3Hl5: "비디오 Y축",
  "Y2Wh/g": "비디오 파일(*.mp4/*.mov)",
  "YLvNj+": "배포 예정",
  kUbrNT:
    "먼저 리소스 관리 센터에 파일을 업로드하세요. 승인된 파일만 템플릿으로 사용할 수 있습니다.",
  n997QX: "비디오 높이",
  rBD8kj: "이미지 가로축",
  uCmncQ: "비디오 너비",
  QwmhEP: "콘텐츠 기록",
  "8vC+0s": "재생 콘텐츠를 선택해야 합니다.",
  "jG/AFY": "확인 후 기기에 새 구성이 적용되며 하루 동안은 변경할 수 없습니다. 정말로 적용하시겠습니까?",
  "AxZAkZ": "이 플랫폼에 업로드된 디지털 콘텐츠는 공개 위험을 줄이기 위해 Amazon Rekognition 콘텐츠 관리 시스템에서 자동으로 검토됩니다. 자동 검토가 실패할 경우, 수동으로 검토할 수 있습니다. 단, 이 경우 플랫폼은 후속적인 결과에 대해 책임을 지지 않습니다.",
  "Oyd/7c": "수동 승인",
  "wyHcKZ": "승인 알림",
  "32HMy/": "{nubis} 캐스트 버전",
  "IS73A4": "시작 시간은 종료 시간보다 클 수 없습니다.",
  "jCAPQ2": "{nubis} 캐스트 모드",
  "sWmzFs": "{ora} 마지막 업데이트 시간",
  "sctjLN": "{ora} 마지막 온라인 시간",
  "uoBkfP": "{ora} 마지막 업데이트 상태",
  "3yichR": "마지막 수정 시간",
  "d+otpZ": "출시 버전",
  "k30s+D": "마지막 출시 시간",
  "9bgunT": "비활성화 시, {ora} 최신 버전을 수동으로 다운로드하여 설치하거나, ​​기기 명령어인 {ora} update를 통해 수동으로 업데이트할 수 있습니다.",
  "Yh8vRi": "활성화 시, {ora} 새 버전이 출시되면 자동으로 다운로드하고 업데이트합니다.",
  "ZO2gEn": "{nubis} 버전",
  "r+yR7v": "{nubis} Cast",
  "uf58G7": "자동 업데이트가 비활성화되면 기기의 {ora} 버전 차이로 인해 일부 기능을 사용하지 못할 수 있습니다.",
  "y98D3X": "비디오 세로축"
};
